var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 1600 1200" },
      attrs: {
        width: "100%",
        height: "100%",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        x: "0",
        y: "0",
        viewBox: "0 0 1600 1200",
        "xml:space": "preserve",
      },
    },
    [
      _c("g", [
        _c("defs", [
          _c("path", { attrs: { id: "SVGID_1_", d: "M52 44h1444v1083H52z" } }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_2_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_1_" },
          }),
        ]),
        _c(
          "g",
          { staticStyle: { "clip-path": "url(#SVGID_2_)" } },
          [
            _c("path", {
              staticStyle: { fill: "#e6e6e6" },
              attrs: {
                d: "m1266.5 904.9 22.1-6.9c1.8-1.2 3.7-2 5.5-3.5l-34.3 11c2.4-.2 4.6-.2 6.7-.6zm-15.5 0 49.9-16.2c1-.8 1.6-1.8 2.6-2.6l-55.8 17.7c1.1.7 2.3.9 3.3 1.1zm-8.7-2.2 65.2-20.9c.8-.6 1-1.4 1.8-2.2l-68.8 21.9c.6.8 1.2.8 1.8 1.2zm-5.1-3.3 74.9-24c.4-.6.8-1.4 1.2-2l-77.2 24.8c.1.6.7 1 1.1 1.2zm-3.8-3.8 81.6-26c.4-.6.4-1.2.8-2l-83.4 26.8c.6.4.8 1 1 1.2zm-2.3-3.9 86.7-27.6c0-.6.4-1.2.4-2l-87.9 28.2c.2.4.4 1 .8 1.4zm-2.2-4.3 90.1-29c0-.6.2-1.2.4-2l-91 29c.1 1 .3 1.4.5 2zm-1.6-4.4 92.8-29.8c0-.6.2-1.2.2-1.8l-93.6 30.1c.2.3.4.9.6 1.5zm-.8-5.3c.2.2-.2.4 0 .6l94.4-30.1c0-.6.2-1.2.2-1.8l-94 30c-.2.3-.4.7-.6 1.3zm5-6.7c-.2.2-.4.6-.8.6l90.4-29c0-.6-.2-1 0-1.6l-88.1 28.4c-.7.6-1.1 1.2-1.5 1.6zm4.3-5.7 84.5-27c0-.6-.2-1-.4-1.6l-83.4 26.8c.1.6-.3 1-.7 1.8zm2.8-5.9 81.4-26c-.2-.6-.2-1-.4-1.6l-80.2 25.8c-.6.8-.6 1.4-.8 1.8zm1.3-5.4 78.8-25c-.2-.6-.4-.8-.4-1.6l-77.8 25c-.4.7-.6 1.1-.6 1.6zm.4-5.1 76.7-24.4c-.2-.6-.4-.8-.6-1.4l-76.3 24.2c.2.6.2 1.2.2 1.6zm-.4-4.9 74.5-23.8c-.2-.6-.4-.8-.6-1.4l-74.1 23.6c.2.6.2 1.4.2 1.6zm-.9-4.5 72.7-23.4c-.2-.6-.8-1-1-1.2l-72.5 23.3c.4.5.6.9.8 1.3zm68.1-28.4-70.7 22.5c.2.6.4.8.6 1.4l71.3-22.9c0-.2-.6-.6-1.2-1zm-4.1-3.6-69 22.1c.2.6.8 1 1 1.2l69.6-22.3c-.6 0-1.2-.6-1.6-1zm-5.5-3.1-65.8 20.9c.2.6.4.8.6 1.4l67.2-21.7c-.8 0-1.2-.4-2-.6zm-6.9-2.6c-.2.2-.4-.2-.6 0l-58.1 18.5c-.2.4-.2 1.2-.2 1.8l61.5-19.7c-1 0-1.8-.4-2.6-.6zm-14.8-.6-37.6 12c-1.2 1-2.6 1.8-3.7 2.8l47.7-15.2c-2.1.2-4.4.2-6.4.4z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_3_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "6684.898",
                  y1: "3337.191",
                  x2: "8080.554",
                  y2: "3337.191",
                  gradientTransform: "translate(-79.12 -69.28) scale(.1805)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#a1e7fc" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#a1e7fc" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_3_)" },
              attrs: {
                d: "M1378.1 570.7c2.8 8.3-.4 17.1-4.5 24.8-11.2 21.1-29.4 38.4-51 48.5-12 5.7-25 9.1-37.4 14.2-36.1 15-65.4 44.9-79.4 81.4 4.1-25.2-9.1-50.2-25.2-70.2-16-19.9-35.3-37.8-46.7-60.7-9.9-19.7-10.1-48.9 9.9-58.3 14.6-6.9 32.9.8 47.9-5.5 5.3-2.4 10.1-7.1 9.9-12.8-.8-14.6-29.6-13.6-30.3-28.2-.8-16.8 43.4-11.8 37.6-27.8-2.4-6.7-11.8-8.7-15-15-3.4-6.3-3.2-15.2 2.6-19.7 7.3-5.9 18.3-1.2 27.6-3.4 10.4-2.4 17.1-13 19.3-23.6 2.2-10.6 1-21.5 2.6-32.1 3.7-26.2 25.2-48.9 51-54.4s54.6 6.7 68.6 29.2c5.7 9.3 8.9 21.7 2.8 30.5-5.3 7.5-16.7 12.4-15.8 21.5 1.2 12.4 24.2 13.6 24.6 26 .4 14.6-29.6 14.6-28.8 29.2.4 6.5 7.3 10.2 11.4 15.4 7.9 9.5 4.7 25.8-6.1 31.7-4.3 2.4-9.5 3.4-12.8 6.7-8.7 8.5-.2 23.4 10.1 29.8 9.9 6.2 23.3 11.2 27.1 22.8z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_4_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "7140.509",
                  y1: "3662.746",
                  x2: "8596.355",
                  y2: "3662.746",
                  gradientTransform: "translate(-79.12 -69.28) scale(.1805)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#deeafe" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#e9f1fe" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_4_)" },
              attrs: {
                d: "M1302.4 571.7c6.1-3.4 12.6-6.5 17.5-11.6 10.1-11 9.5-27.6 10.2-42.6s6.1-32.5 20.5-36.5c12-3.4 27.2 3.9 36.1-4.7 3.4-3.2 4.7-7.9 7.1-11.8 10.2-17.1 37.2-15.8 52.2-2.6 14.8 13.2 20.5 33.7 25.4 53 1.8 7.1 2 16.9-4.9 18.9-6.7 1.8-13.4-6.5-19.7-3.9-5.1 2-5.5 9.3-3.5 14.6 1.8 5.1 4.9 10.4 3.7 16-2.4 10.2-16.7 10.8-27 8.1-10.2-2.8-23.4-5.5-29.4 3.4 6.5 20.7 12 45.9-2.6 62.3-16.7 18.7-47.7 16.8-72.7 19.1-46.5 4.3-79.4 39.8-105.6 78.6-1.5-65.2 35.8-129.4 92.7-160.3z",
              },
            }),
            _c("path", {
              staticClass: "st4",
              attrs: {
                d: "M1244.1 702.3h-.4c-.6-.2-.8-.8-.6-1.2 23.6-72.3 61.3-122.6 130.1-173.2 12.8-9.5 51.4-25.4 68.2-26.8.4 0 1 .4 1 1s-.4 1-1 1c-16 1.4-54.8 17.3-67 26.4-68.6 50.4-106 100.3-129.5 172.2 0 .2-.4.6-.8.6zM1280.5 490.3l-7.9-21.7c-2.8-.2-5.7.2-8.5 1.2l8.5 23.3c.4 1.4-.2 2.8-1.6 3.2-1.4.4-2.8-.2-3.2-1.6l-8.5-22.9c-2.6 1.6-4.7 3.7-6.5 6.1l7.1 19.3c.4 1.4-.2 2.8-1.6 3.2-1.4.4-2.8-.2-3.2-1.6l-5.5-15.2c-3.2 7.9-3.4 17.9.2 27.8 0 .2.2.4.2.6-1.8 1-3.7 2.2-5.3 3.5-4.9 3.5-11.2 9.7-13.4 18.3l2.4.6c2-7.9 7.9-13.6 12.4-16.8 1.6-1.2 3.2-2.2 4.9-3.2 3.7 8.3 9.9 15 16.6 18.5l-5.3-14.4c-.4-1.4.2-2.8 1.6-3.2 1.4-.4 2.8.2 3.2 1.6l6.9 18.5c3 .8 5.9 1 8.9.4l-7.9-21.7c-.4-1.4.2-2.8 1.6-3.2 1.4-.4 2.8.2 3.2 1.6l8.1 21.9c2.6-1.2 4.9-3 6.9-4.9l-7.3-19.7c-.4-1.4.2-2.8 1.6-3.2 1.4-.4 2.8.2 3.2 1.6l6.3 16.9c2-3 3.7-6.1 5.3-9.5L1300 505c-.4-1.4.2-2.8 1.6-3.2 1.4-.4 2.8.2 3.2 1.6l2.2 5.7c3.9-9.5 6.5-18.7 9.9-21.7-5.5-1.2-13.2-6.3-21.7-11l2.8 7.3c.4 1.4-.2 2.8-1.6 3.2-1.4.4-2.8-.2-3.2-1.6l-4.5-12.4c-3.4-1.6-6.7-2.8-10.1-3.5l6.9 19.1c.4 1.4-.2 2.8-1.6 3.2-1.4.6-2.8 0-3.4-1.4z",
              },
            }),
            _c("path", {
              staticStyle: { fill: "#d6d7d8" },
              attrs: { d: "M670.8 731.7h219.9v244.5H670.8z" },
            }),
            _c("path", {
              staticClass: "st6",
              attrs: { d: "M534.7 968.3h492.2v18.9H534.7z" },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_5_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "2088.347",
                  y1: "3579.37",
                  x2: "7439.897",
                  y2: "3579.37",
                  gradientTransform: "translate(-79.12 -69.28) scale(.1805)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#eee" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#d6d7d8" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_5_)" },
              attrs: { d: "M297.8 264.1h966v625.4h-966z" },
            }),
            _c("path", {
              staticClass: "st4",
              attrs: { d: "M314.8 279.6h932.1v515.1H314.8z" },
            }),
            _c("path", {
              staticClass: "st8",
              attrs: {
                transform: "rotate(-45.001 746.16 843.104)",
                d: "M737.2 834.1h17.9V852h-17.9z",
              },
            }),
            _c("path", {
              staticClass: "st4",
              attrs: {
                transform: "rotate(-45.001 780.748 843.077)",
                d: "M771.8 834.1h17.9V852h-17.9z",
              },
            }),
            _c("path", {
              staticClass: "st9",
              attrs: {
                transform: "rotate(-45.001 815.336 843.131)",
                d: "M806.4 834.2h17.9v17.9h-17.9z",
              },
            }),
            _c(
              "g",
              [
                _c(
                  "linearGradient",
                  {
                    attrs: {
                      id: "SVGID_6_",
                      gradientUnits: "userSpaceOnUse",
                      x1: "3443.302",
                      y1: "3904.401",
                      x2: "4849.403",
                      y2: "3904.401",
                      gradientTransform:
                        "matrix(-.174 .04783 .04783 .174 808.892 -90.739)",
                    },
                  },
                  [
                    _c("stop", {
                      staticStyle: { "stop-color": "#a1e7fc" },
                      attrs: { offset: "0" },
                    }),
                    _c("stop", {
                      staticStyle: { "stop-color": "#a1e7fc" },
                      attrs: { offset: "1" },
                    }),
                  ],
                  1
                ),
                _c("path", {
                  staticStyle: { fill: "url(#SVGID_6_)" },
                  attrs: {
                    d: "M162.8 856.8c-.4 8.7 4.9 16.6 11 22.9 16.6 17.5 38.8 29.6 62.5 33.5 13.2 2.2 26.8 2.2 40.2 3.7 39 4.9 75.5 26.2 98.9 57.7-10.8-23.4-4.5-51.2 5.7-74.9 10.2-23.6 24.2-46.1 29.2-71.3 4.3-21.7-3.4-50.2-25.2-54-16.2-2.8-31.9 9.7-48.1 7.3-5.7-.8-11.8-4.1-13-9.9-3.2-14.4 25.2-21.1 21.9-35.5-3.7-16.6-45.3 0-43.9-16.8.6-7.1 9.1-11.4 10.6-18.5 1.6-7.1-1-15.6-7.7-18.3-8.7-3.7-18.1 3.7-27.6 4.1-10.8.6-20.1-8.1-25-17.7-4.9-9.7-6.7-20.7-11-30.5-10.6-24.4-37.4-40.8-64-39.2-26.6 1.6-51.2 21.1-58.9 46.7-3.2 10.4-3 23.4 5.5 30.5 7.1 5.9 19.5 7.5 21.1 16.6 2.2 12.4-19.9 19.7-16.9 31.9 3.4 14.4 32.7 6.3 35.7 20.7 1.4 6.5-4.3 12-6.9 17.9-5.1 11.2 2.4 26.2 14.4 29.2 4.7 1.2 10.1.6 14.4 3 10.6 5.9 6.5 22.7-1.8 31.5-8.8 9.1-20.3 17.2-21.1 29.4z",
                  },
                }),
                _c(
                  "linearGradient",
                  {
                    attrs: {
                      id: "SVGID_7_",
                      gradientUnits: "userSpaceOnUse",
                      x1: "3900.884",
                      y1: "4233.032",
                      x2: "5367.94",
                      y2: "4233.032",
                      gradientTransform:
                        "matrix(-.174 .04783 .04783 .174 808.892 -90.739)",
                    },
                  },
                  [
                    _c("stop", {
                      staticStyle: { "stop-color": "#deeafe" },
                      attrs: { offset: "0" },
                    }),
                    _c("stop", {
                      staticStyle: { "stop-color": "#e9f1fe" },
                      attrs: { offset: "1" },
                    }),
                  ],
                  1
                ),
                _c("path", {
                  staticStyle: { fill: "url(#SVGID_7_)" },
                  attrs: {
                    d: "M236.9 837.7c-6.9-1.6-14-3-20.1-6.7-12.8-8.1-16.6-24.4-21.3-38.6-4.7-14.2-14.6-30-29.6-30-12.6 0-25.4 11.2-36.3 5.1-4.1-2.4-6.7-6.5-10.1-9.7-14.4-13.8-40.4-5.3-51.2 11.4-10.8 16.8-10.8 38.2-10.6 58.3.2 7.3 2.6 16.9 9.9 16.9 6.9 0 11.2-9.9 18.1-9.1 5.5.6 7.9 7.7 7.5 13.2-.4 5.5-2 11.4.6 16.4 4.9 9.5 19.3 6.1 28.4.6s21.3-11.6 29.4-4.5c-.8 21.9.6 47.9 19.1 59.7 21.3 13.6 50.8 3.5 75.7-.8 46.3-8.3 87.9 17.5 123.6 48.3-16.4-63.3-69.6-115.7-133.1-130.5z",
                  },
                }),
                _c("path", {
                  staticClass: "st12",
                  attrs: { d: "M374.9 977.6c-15.8-41.2-28.4-83.5-38-126.5" },
                }),
                _c("ellipse", {
                  staticClass: "st13",
                  attrs: {
                    transform: "rotate(-12.916 336.45 846.75)",
                    cx: "336.5",
                    cy: "846.7",
                    rx: "22.5",
                    ry: "8.5",
                  },
                }),
                _c("path", {
                  staticClass: "st12",
                  attrs: { d: "M335.7 846c-5.3-24.4-9.7-48.9-13-73.7" },
                }),
                _c("ellipse", {
                  staticClass: "st13",
                  attrs: {
                    transform: "rotate(-18.504 321.876 766.552)",
                    cx: "321.9",
                    cy: "766.6",
                    rx: "27",
                    ry: "10.1",
                  },
                }),
                _c("path", {
                  staticClass: "st12",
                  attrs: { d: "M321.7 765.8c-2.6-20.5-4.5-41-5.9-61.5" },
                }),
                _c("ellipse", {
                  staticClass: "st13",
                  attrs: {
                    transform: "matrix(.9999 -.0106 .0106 .9999 -7.373 3.4)",
                    cx: "317.1",
                    cy: "697.2",
                    rx: "27",
                    ry: "10",
                  },
                }),
                _c("path", {
                  staticClass: "st12",
                  attrs: { d: "M315.4 695.6c-.8-15.6-1.2-31.3-1.4-47.1" },
                }),
                _c("ellipse", {
                  staticClass: "st13",
                  attrs: {
                    transform: "matrix(.9999 -.0106 .0106 .9999 -6.771 3.366)",
                    cx: "314.2",
                    cy: "640.5",
                    rx: "36.3",
                    ry: "13.6",
                  },
                }),
                _c("path", {
                  staticClass: "st12",
                  attrs: { d: "M314 637.9c.2-10.4.4-20.9.8-31.3" },
                }),
              ],
              1
            ),
            _c("path", {
              staticClass: "st4",
              attrs: {
                d: "m291.7 919.3 7.9-21.7c2.8-.2 5.7.2 8.5 1.2l-8.5 23.3c-.4 1.4.2 2.8 1.6 3.2 1.4.4 2.8-.2 3.2-1.6l8.5-22.9c2.6 1.6 4.7 3.7 6.5 6.1l-7.1 19.3c-.4 1.4.2 2.8 1.6 3.2 1.4.4 2.8-.2 3.2-1.6l5.5-15.2c3.2 7.9 3.4 17.9-.2 27.8 0 .2-.2.4-.2.6 1.8 1 3.7 2.2 5.3 3.5 4.9 3.5 11.2 9.7 13.4 18.3l-2.4.6c-2-7.9-7.9-13.6-12.4-16.8-1.6-1.2-3.2-2.2-4.9-3.2-3.7 8.3-9.9 15-16.6 18.5l5.3-14.4c.4-1.4-.2-2.8-1.6-3.2-1.4-.4-2.8.2-3.2 1.6l-6.9 18.5c-3 .8-5.9 1-8.9.4l7.9-21.7c.4-1.4-.2-2.8-1.6-3.2-1.4-.4-2.8.2-3.2 1.6l-8.1 21.9c-2.6-1.2-4.9-3-6.9-4.9l7.3-19.7c.4-1.4-.2-2.8-1.6-3.2-1.4-.4-2.8.2-3.2 1.6l-6.3 16.9c-2-3-3.7-6.1-5.3-9.5l3.9-10.6c.4-1.4-.2-2.8-1.6-3.2-1.4-.4-2.8.2-3.2 1.6l-2.2 5.7c-3.9-9.5-6.5-18.7-9.9-21.7 5.5-1.2 13.2-6.3 21.7-11l-2.8 7.3c-.4 1.4.2 2.8 1.6 3.2 1.4.4 2.8-.2 3.2-1.6l4.5-12.4c3.4-1.6 6.7-2.8 10.1-3.5l-6.9 19.1c-.4 1.4.2 2.8 1.6 3.2 1.4.5 2.8 0 3.4-1.4z",
              },
            }),
            _c("path", {
              staticClass: "st14",
              attrs: {
                d: "m249.7 289.5-14.8-1.8c-1.4.2-2.8.2-4.1.6l23.1 2.6c-1.6-.4-2.8-1-4.2-1.4zm9.1 4.1-33.5-3.7c-.8.2-1.4.6-2.2.8l37.4 4.3c-.5-.6-1.1-1-1.7-1.4zm4.5 3.6-43.7-4.9c-.6.2-1 .6-1.6.8l46.1 5.3c-.2-.6-.6-.8-.8-1.2zm2.2 3.3-50.2-5.7c-.4.2-.8.6-1.2.8l51.8 5.9c0-.4-.2-.8-.4-1zm1.2 3.2-54.8-6.3c-.4.2-.6.6-1 1l56 6.3c-.2-.4-.2-.8-.2-1zm.4 2.9-58.1-6.7c-.2.4-.6.6-.8 1l58.9 6.7v-1zm0 3.2-60.5-6.9c-.2.4-.4.6-.8 1l61.1 7.1c.2-.6.2-.8.2-1.2zm-.2 2.9-62.3-7.1c-.2.4-.4.6-.6 1l62.9 7.1v-1zm-1 3.4c0-.2.2-.2.2-.4l-63.3-7.3c-.2.4-.4.6-.6 1l63.1 7.3.6-.6zm-4.5 2.6c.2 0 .4-.2.6-.2l-60.7-6.9c-.2.4-.2.6-.4 1l59.1 6.7c.6-.2 1-.4 1.4-.6zm-4.2 2.1-56.8-6.5c-.2.4-.2.6-.2 1l56 6.3c.2-.2.6-.4 1-.8zm-3.1 2.8-54.6-6.3c0 .4-.2.6-.2 1l53.8 6.1c.6-.2.8-.6 1-.8zm-2.2 2.7-52.8-6.1c0 .4 0 .6-.2 1l52.2 5.9c.4-.2.6-.4.8-.8zm-1.6 3-51.4-5.9v1l51 5.9c0-.4.2-.8.4-1zm-1.1 3-50.1-5.7v1l49.7 5.7c.2-.5.4-.9.4-1zm-.6 2.9-48.9-5.5c0 .4.2.8.2 1l48.7 5.5v-1zm-47.5-1.4 47.5 5.5v-1l-47.9-5.5c0 .2.2.6.4 1zm1.6 3.2 46.3 5.3c0-.4-.2-.8-.2-1l-46.7-5.3c.2.2.4.6.6 1zm2.3 3.3 44.1 5.1v-1l-45.1-5.1c.4.2.6.6 1 1zm3.4 3.4c.2 0 .2.2.4.2l39 4.5c.2-.2.4-.6.6-1l-41.2-4.7c.4.2.8.6 1.2 1zm8.4 4.1 25.2 3 3-.6-31.9-3.7c1.2.3 2.6.9 3.7 1.3zM1292.2 941.5l23.1 1c2.2-.4 4.3-.6 6.3-1.4l-36.1-1.2c2.5.5 4.5 1.2 6.7 1.6zm-14.6-5.3 52.4 1.8c1.2-.4 2-1 3.4-1.6l-58.5-2.2c.9 1 1.7 1.6 2.7 2zm-7.3-4.9 68.4 2.4c1-.4 1.4-1 2.4-1.4l-72.1-2.8c.3 1 .9 1.2 1.3 1.8zm-4-4.9 78.6 2.8c.6-.4 1.2-1 1.8-1.4l-81-3c.1.8.4 1.4.6 1.6zm-2.1-4.8 85.7 3.2c.6-.4.8-1 1.4-1.6l-87.5-3.2c.4.7.4 1.2.4 1.6zm-1-4.5 90.8 3.4c.2-.6.8-1 1.2-1.6l-92.2-3.4c.2.4.2 1 .2 1.6zm-.4-4.9 94.6 3.5c.2-.6.6-1 1.2-1.6l-95.6-3.7c-.2 1-.2 1.2-.2 1.8zm0-4.6 97.3 3.5c.2-.6.6-1 .8-1.6l-98.3-3.5c.2.5.2 1.1.2 1.6zm1.2-5.3c0 .4-.2.4-.2.6l98.9 3.7c.2-.6.6-1 .8-1.6l-98.5-3.7c-.4.4-.8.6-1 1zm6.7-4.5c-.4 0-.6.4-1 .4l95 3.4c.2-.6.2-1 .6-1.6l-92.4-3.4c-1 .4-1.6.8-2.2 1.2zm6.1-3.9 88.7 3.4c.2-.6.2-1 .2-1.6l-87.5-3.2c-.2.4-.8.8-1.4 1.4zm4.5-4.6 85.3 3.2c0-.6.2-1 .2-1.6l-84.1-3c-.8.4-1 1-1.4 1.4zm3.2-4.5 82.6 3.2c0-.6 0-1 .2-1.6l-81.6-3c-.8.4-1 .8-1.2 1.4zm1.9-4.7 80.4 3c0-.6 0-1-.2-1.6l-79.8-3.2c.2.8 0 1.4-.4 1.8zm1.6-4.8 78.2 3c0-.6 0-1-.2-1.6l-77.6-3c-.2.6-.4 1.2-.4 1.6zm.6-4.7 76.5 2.8c0-.6-.4-1.2-.4-1.6l-76.1-2.8c-.2.6 0 1.2 0 1.6zm73.7-3.5-74.3-3c0 .6 0 1 .2 1.6l74.9 2.8c0-.3-.4-.9-.8-1.4zm-2.8-4.8-72.3-2.8c0 .6.4 1.2.4 1.6l73.1 2.8c-.6-.4-.8-1-1.2-1.6zm-4.1-4.9-69-2.8c0 .6 0 1 .2 1.6l70.5 2.6c-.7-.2-1.1-.8-1.7-1.4zm-5.5-4.7c-.4 0-.4-.2-.6-.2l-61.1-2.4c-.2.4-.6 1-.8 1.6l64.4 2.4c-.7-.2-1.3-.8-1.9-1.4zm-13.6-5.3-39.4-1.6c-1.6.4-3 .8-4.5 1.2l49.9 2c-2.1-.5-4.2-1.3-6-1.6z",
              },
            }),
          ],
          1
        ),
      ]),
      _c("defs", [
        _c("path", { attrs: { id: "SVGID_8_", d: "M405 318h754v457H405z" } }),
      ]),
      _c("clipPath", { attrs: { id: "SVGID_9_" } }, [
        _c("use", {
          staticStyle: { overflow: "visible" },
          attrs: { "xlink:href": "#SVGID_8_" },
        }),
      ]),
      _c(
        "g",
        { staticStyle: { "clip-path": "url(#SVGID_9_)" } },
        [
          _c("path", {
            staticClass: "st16",
            attrs: { d: "m999.8 369 88 125.8-161.1 113-88-125.8z" },
          }),
          _c("path", {
            staticClass: "st16",
            attrs: {
              d: "M699.2 685.2 669.7 643c-21.3-30.5-13.9-72.5 16.5-93.8l66.9-46.9c54.8-38.5 130.4-25.1 168.8 29.8l22.9 32.8c21.3 30.5 13.9 72.5-16.5 93.8l-76.2 53.5c-49.6 34.9-118.1 22.8-152.9-27z",
            },
          }),
          _c("path", {
            staticClass: "st17",
            attrs: { d: "m496.2 510.4 87.9-125.8 161.1 113-87.9 125.8z" },
          }),
          _c("path", {
            staticClass: "st17",
            attrs: {
              d: "M891.5 665.7 878 685.2c-40.1 57.3-118.9 71.3-176.2 31.1l-63.3-44.4c-30-21-37.3-62.5-16.3-92.5l48.1-68.9c21-30 62.3-37.4 92.3-16.3l112.6 79c30.1 21.1 37.3 62.5 16.3 92.5z",
            },
          }),
          _c("path", {
            staticClass: "st18",
            attrs: {
              d: "m1159 488.5-98 68.7c-21.3 15-50.7 9.8-65.6-11.6l-92.2-131.9 136.6-95.8L1159 488.5zM503 562.3l-98-68.7L524.2 323l136.6 95.8-92.2 131.9c-14.9 21.4-44.3 26.6-65.6 11.6z",
            },
          }),
          _c("path", {
            staticClass: "st16",
            attrs: {
              d: "m688 705.7-31.6 22.2c-7.3 5.1-17.4 3.4-22.5-4l-12.7-18.2c-5.1-7.3-3.3-17.4 4-22.6l31.6-22.2c12.3-8.6 29.3-5.6 37.9 6.7 8.6 12.4 5.6 29.4-6.7 38.1zM696.6 455.6l115.5-.7c40.6-.2 73.8 32.6 74 73.3l-125.9.7c-34.9.2-63.3-28-63.5-62.9l-.1-10.4z",
            },
          }),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "SVGID_10_",
                gradientUnits: "userSpaceOnUse",
                x1: "-53.09",
                y1: "1072.843",
                x2: "-46.831",
                y2: "1079.797",
                gradientTransform:
                  "matrix(3.5691 .6304 .6292 -3.576 169.91 4563.764)",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#fed8d4" },
                attrs: { offset: "0" },
              }),
              _c("stop", {
                staticStyle: { "stop-color": "#ffbeb6" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _c("circle", {
            staticStyle: { fill: "url(#SVGID_10_)" },
            attrs: { cx: "672.8", cy: "680.2", r: "16.9" },
          }),
          _c("path", {
            staticClass: "st16",
            attrs: {
              d: "m733 737-24 16.8c-7.3 5.1-17.4 3.4-22.5-4l-12.7-18.2c-5.1-7.3-3.3-17.4 4-22.6l24-16.8c12.3-8.6 29.3-5.6 37.9 6.7 8.6 12.5 5.6 29.5-6.7 38.1z",
            },
          }),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "SVGID_11_",
                gradientUnits: "userSpaceOnUse",
                x1: "-38.828",
                y1: "1067.091",
                x2: "-32.57",
                y2: "1074.044",
                gradientTransform:
                  "matrix(3.5691 .6304 .6292 -3.576 169.91 4563.764)",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#fed8d4" },
                attrs: { offset: "0" },
              }),
              _c("stop", {
                staticStyle: { "stop-color": "#ffbeb6" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _c("circle", {
            staticStyle: { fill: "url(#SVGID_11_)" },
            attrs: { cx: "717.8", cy: "711.5", r: "16.9" },
          }),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "SVGID_12_",
                gradientUnits: "userSpaceOnUse",
                x1: "9.828",
                y1: "1038.098",
                x2: "2.828",
                y2: "1043.098",
                gradientTransform:
                  "matrix(3.6242 0 0 -3.6312 824.869 4517.591)",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#fdbab3" },
                attrs: { offset: "0" },
              }),
              _c("stop", {
                staticStyle: { "stop-color": "#f2a19c" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _c("path", {
            staticStyle: { fill: "url(#SVGID_12_)" },
            attrs: {
              d: "m839.6 695.6 19 13.3c8.2 5.8 10.2 17.1 4.5 25.3l-14.2 20.4c-5.7 8.2-17.1 10.2-25.3 4.5l-19-13.3c-13.8-9.7-17.2-28.8-7.5-42.6 9.6-13.9 28.7-17.3 42.5-7.6z",
            },
          }),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "SVGID_13_",
                gradientUnits: "userSpaceOnUse",
                x1: "11.237",
                y1: "1058.678",
                x2: "-.767",
                y2: "1065.181",
                gradientTransform:
                  "matrix(3.825 .1409 -.1406 -3.73 1027.436 4659.843)",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#fdbab3" },
                attrs: { offset: "0" },
              }),
              _c("stop", {
                staticStyle: { "stop-color": "#f2a19c" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _c("path", {
            staticStyle: { fill: "url(#SVGID_13_)" },
            attrs: {
              d: "m889.7 658.4 23.9 16.8c8.2 5.8 10.2 17.1 4.5 25.3l-14.2 20.4c-5.7 8.2-17.1 10.2-25.3 4.5l-23.9-16.8c-13.8-9.7-17.2-28.8-7.5-42.6 9.6-13.9 28.7-17.3 42.5-7.6z",
            },
          }),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "SVGID_14_",
                gradientUnits: "userSpaceOnUse",
                x1: "-6.579",
                y1: "1091.684",
                x2: "-19.582",
                y2: "1099.686",
                gradientTransform:
                  "matrix(4.4693 .593 -.5918 -4.0463 1650.359 5096.554)",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#fdbab3" },
                attrs: { offset: "0" },
              }),
              _c("stop", {
                staticStyle: { "stop-color": "#f2a19c" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _c("path", {
            staticStyle: { fill: "url(#SVGID_14_)" },
            attrs: {
              d: "m864 565.3 100 70.2c8.2 5.8 10.2 17.1 4.5 25.3l-14.2 20.4c-5.7 8.2-17.1 10.2-25.3 4.5l-100-70.2c-13.8-9.7-17.2-28.8-7.5-42.6 9.7-14 28.7-17.3 42.5-7.6z",
            },
          }),
          _c("path", {
            staticClass: "st16",
            attrs: {
              d: "m786.2 760.2-17 11.9c-7.3 5.1-17.4 3.4-22.5-4L734 749.9c-5.1-7.3-3.3-17.4 4-22.6l17-11.9c12.3-8.6 29.3-5.6 37.9 6.7 8.6 12.4 5.6 29.4-6.7 38.1z",
            },
          }),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "SVGID_15_",
                gradientUnits: "userSpaceOnUse",
                x1: "-22.743",
                y1: "1063.945",
                x2: "-16.485",
                y2: "1070.898",
                gradientTransform:
                  "matrix(3.5691 .6304 .6292 -3.576 169.91 4563.764)",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#fed8d4" },
                attrs: { offset: "0" },
              }),
              _c("stop", {
                staticStyle: { "stop-color": "#ffbeb6" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _c("circle", {
            staticStyle: { fill: "url(#SVGID_15_)" },
            attrs: { cx: "771", cy: "734.7", r: "16.9" },
          }),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "SVGID_16_",
                gradientUnits: "userSpaceOnUse",
                x1: "-17.039",
                y1: "1115.228",
                x2: "-28.495",
                y2: "1114.819",
                gradientTransform:
                  "matrix(3.6242 0 0 -3.6312 824.869 4517.591)",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#fed8d4" },
                attrs: { offset: "0" },
              }),
              _c("stop", {
                staticStyle: { "stop-color": "#ffbeb6" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _c("path", {
            staticStyle: { fill: "url(#SVGID_16_)" },
            attrs: {
              d: "M712.3 454.9c-.2.7-.4 1.4-.5 2.2-2.2 12.4 6.1 24.2 18.5 26.4 12.4 2.2 24.2-6.1 26.4-18.5.6-3.5.4-6.9-.5-10.1h-43.9z",
            },
          }),
        ],
        1
      ),
      _c("g", [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_17_", d: "M902 649h327v466H902z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_18_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_17_" },
          }),
        ]),
        _c(
          "g",
          { staticStyle: { "clip-path": "url(#SVGID_18_)" } },
          [
            _c("path", {
              staticClass: "st17",
              attrs: {
                d: "M1167.1 851.2c1.1 2.1 2.1 4.2 2.9 6.4.2.7.5 1.4 1 1.8 1.3 1.1 3.5 0 4-1.7.4-1.7-.3-3.4-1.2-4.9-1.2-2-2.7-3.7-4.4-5.2-.5-.4-1.1-.9-1.7-.8-.9.1-1.5 1.1-1.4 1.9-.1.9.4 1.7.8 2.5z",
              },
            }),
            _c("path", {
              staticClass: "st9",
              attrs: {
                d: "M1134.7 770.1c-4.2 10.7-9 19.1-11.2 18.3-2.3-.8-.9-10.7 3.3-21.4s9.4-18.8 11.6-17.9c2.2.9.5 10.3-3.7 21zM1037 842.1c.8 1.8 3.6 1.5 5.6 1.1 26.4-5.9 49.8-14 72.6-28.5.9-.5 4.7-2.3 3.9-3-.3-.3-4.6-2-5.1-2-12.2 1.4-23.4 3.8-34.9 8.1-12 4.5-37.7 17.9-42.1 24.3z",
              },
            }),
            _c("g", { attrs: { id: "shoes_11_-i2" } }, [
              _c("path", {
                staticClass: "st18",
                attrs: {
                  id: "R_shoe_11_-i2",
                  d: "m989.5 1074.7 14.4 40.3h-102s5.2-10.1 22.7-17.6c17.4-7.5 31.6-22.8 31.6-22.8l33.3.1",
                },
              }),
            ]),
            _c("g", { attrs: { id: "shoes_12_-i2" } }, [
              _c("path", {
                staticClass: "st18",
                attrs: {
                  id: "R_shoe_12_-i2",
                  d: "m1214.6 1074.7 14.4 40.3h-102s5.2-10.1 22.7-17.6c17.4-7.5 31.6-22.8 31.6-22.8l33.3.1",
                },
              }),
            ]),
            _c("path", {
              staticClass: "st16",
              attrs: {
                d: "M1057.5 776c-9.6 17.5-21.6 33.7-35.7 47.9-5.7 5.8-11.9 11.4-19.7 13.7-6.5 2-14 1.6-19.7 5.4-4.6 3-12 12.5-9.7 13.1 5.8 1.5 10.4-4.4 15.4-9.3 11.1 2.6 12.4 8.5 16 8.9 2 .2 6.8-6.4 8.2-8.1 10.4-12.2 39.2-34.1 61.3-47.7-3.9-8.8-9.4-16.9-16.1-23.9z",
              },
            }),
            _c("path", {
              staticClass: "st27",
              attrs: {
                d: "M1113.9 811.8c11.5 22.7 19.8 47 24.6 71.9 3.4 17.4 3.4 42.2 12.4 57.5 10.3 17.5 29.6 30.4 35 50 2.5 9.1 3.4 12.1 7.4 20.7 4.1 8.8 12.6 14.8 17.6 23.1 7.6 12.6 6.5 28.5 4.9 43.2-8.3-3.2-18-3.3-26.3-.2-3.7 1.4-12.7 1.2-12.7 1.2s-56.5-86.7-72.6-122.1c-19.7-43.3-15.2-96.9-43.7-135-1.1-1.4-2.3-3.1-2-4.9.4-2.6 3.5-3.6 6.1-4 16.4-2.5 33-3.1 49.3-1.4z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_19_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "5244.046",
                  y1: "3743.231",
                  x2: "4000.226",
                  y2: "3961.492",
                  gradientTransform: "matrix(.1376 0 0 .1377 408.566 409.746)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#23286b" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#151a4f" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_19_)" },
              attrs: {
                d: "M1127.8 844.3c-7.2-38.2-16.1-34.8-33.1-54.3-1.1 3.9-29 25.6-37.6 25.5 7.1 11.7 11.3 21.5 18.3 33.2-5.5 8.6-7.7 19.2-11.8 28.5-6.1 13.8-10 28.5-15.3 42.6-21.8 58.1-65.8 102.1-94.4 157.3 14.2.8 26.9 13.8 41.1 13.2 20-.8 33.2-22.8 33.4-42.8 0-2.8-.1-5.7.8-8.4 2.1-6.3 9-9.4 14.2-13.6 8.4-6.7 15.4-31.6 15.6-34.6.5-9 8.3-15.6 15-21.7 20.9-18.9 33.2-45.5 43.4-71.7 5.1-13.1 12.4-42.4 10.4-53.2z",
              },
            }),
            _c("path", {
              staticClass: "st17",
              attrs: {
                d: "M1048.6 702c-7-5.3-11.6-13.7-12.3-22.5-3.8 2.6-8 4.8-12.3 6.3 6.2 6.4 12.7 13.4 13.6 22.2 7.4 2.2 10.4-1 11-6z",
              },
            }),
            _c("path", {
              staticClass: "st16",
              attrs: {
                d: "M1040 651c-3.3.2-6.5 2.3-9.6 5-3.1 2.7-6.1 5.3-10.1 6.3-2.3.6-4.2.5-4.4 2.8-.2 2.3 1 4.4.1 6.4-1 2-2.4 3.9-3 6-1.7 6 3.7 12.1 9.8 13.4 6.1 1.3 23-4.7 25.3-6 2.4-1.3 4.6-4.1 6.4-6.2 1.7-2 2.7-4.6 3.4-7.2 1.5-5.1 2.1-11.2-1.4-15.2-4-4.1-10.7-6.1-16.5-5.3z",
              },
            }),
            _c("path", {
              staticClass: "st29",
              attrs: {
                d: "M1032.7 677.9c.3 1.5 3.2 4.1 4.3 5.2 4.3 4.3-6.2 7.7 20 15 3.9 1.1 13 .7 15.6 3.9 9.8-6.7 20.5-14.7 22.4-26.4-7.8 1.6-15.6-2.4-22.5-6.4-2.1-1.2-4.3-2.5-5.9-4.3-1.2-1.3-2.1-2.8-3.1-4.1-4.5-6.1-11.7-10.2-19.3-10.8-2.6-.2-5.3 0-7.5 1.3-4 2.4-5.2 7.7-5.3 12.3-.1 4.7.3 9.6 1.3 14.3z",
              },
            }),
            _c("path", {
              staticClass: "st29",
              attrs: {
                d: "M1093.6 668.8c-8.6 0-17.2-1.1-23.4-6.4-.8-.7-1.5-1.4-2.2-2.1-.6-.6-1.2-1.2-1.9-1.8-3.4-3-8.9-6.8-15.3-7.8-8.9-1.4-11.6-.7-13.9 1.2-.2.2-.5.1-.7-.1-.2-.2-.2-.5.1-.7 2.5-2.1 5.4-2.9 14.7-1.4 6.7 1 12.3 5 15.8 8.1.7.6 1.3 1.2 1.9 1.8.7.7 1.4 1.4 2.2 2 6.9 5.8 16.8 6.3 26.5 6.1.3 0 .5.2.5.5s-.2.5-.5.5c-1.3 0-2.6.1-3.8.1z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_20_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "4536.499",
                  y1: "2623.023",
                  x2: "5163.929",
                  y2: "2623.023",
                  gradientTransform: "matrix(.1376 0 0 .1377 408.566 409.746)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#008ec6" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#009bd3" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_20_)" },
              attrs: {
                d: "M1037 842.2c20.2-16.4 48.6-26.7 82.3-30.3-17.5-14.6-24.4-37.8-32.2-59.2-4.9-13.4-10.1-38.4-23-44.2-7.3-3.3-10-5.4-17.9-8.6.1 5.2-4.9 8.8-8.8 6.2-1.7 23-5 31-4.3 54.1.6 23 15.1 60.9 3.9 82z",
              },
            }),
            _c("path", {
              staticClass: "st6",
              attrs: {
                d: "M1023.2 666.7c-.7 0-1.3-.2-1.7-.6-1.6-1.5-.5-5 2.4-8.1 2.1-2.2 4.4-3.5 6.2-3.5.7 0 1.3.2 1.7.6 1.6 1.5.5 5-2.4 8.1-2 2.2-4.4 3.5-6.2 3.5zm7-11c-1.4 0-3.6 1.3-5.3 3.1-2.5 2.6-3.4 5.5-2.5 6.3.2.2.5.3.9.3 1.4 0 3.6-1.3 5.3-3.1 2.5-2.6 3.4-5.5 2.5-6.3-.2-.2-.5-.3-.9-.3z",
              },
            }),
            _c("path", {
              staticClass: "st4",
              attrs: {
                transform: "rotate(-14.637 1059.51 772.921)",
                d: "M1051.5 757.3h16.3v31.4h-16.3z",
              },
            }),
            _c("path", {
              staticClass: "st4",
              attrs: {
                d: "M1063.6 756c1.1 4.3-1.2 10.5-5.5 11.6-4.3 1.1-9.1-3.1-10.2-7.3",
              },
            }),
            _c("path", {
              staticClass: "st13",
              attrs: {
                d: "M1056.6 768.2c-4.1 0-8.3-3.9-9.3-7.9-.1-.3.1-.5.4-.6.3-.1.5.1.6.4 1 4 5.7 8 9.6 7 4-1 6.2-7 5.2-11-.1-.3.1-.5.4-.6.3-.1.5.1.6.4.6 2.2.3 4.9-.8 7.3-1.1 2.6-3 4.3-5.1 4.9-.5.1-1.1.1-1.6.1z",
              },
            }),
            _c("circle", {
              staticClass: "st13",
              attrs: { cx: "1057.2", cy: "764.9", r: "1.5" },
            }),
            _c("path", {
              staticClass: "st4",
              attrs: {
                d: "M1051.9 759.4c-.1 0-.3-.1-.4-.2-2.7-2.9-5.8-6.5-7.5-10.9-.9-2.2-1.4-4.4-1.9-6.6-.4-1.9-.9-3.9-1.6-5.7-.6-1.7-1.4-3.3-2.2-4.9-1-2.1-2.1-4.3-2.7-6.6-1.7-6.2-.7-11.1.9-17.8.1-.3.3-.4.6-.4.3.1.4.3.4.6-1.6 6.6-2.6 11.4-.9 17.3.6 2.2 1.7 4.4 2.7 6.5.8 1.6 1.6 3.3 2.2 5 .7 1.9 1.1 3.9 1.6 5.8.5 2.2 1 4.4 1.9 6.5 1.7 4.2 4.6 7.7 7.3 10.6.2.2.2.5 0 .7-.2.1-.3.1-.4.1zM1060 759.3c-.2 0-.3-.1-.4-.3-5.6-10-6.7-21.6-7.8-32.8-.9-9.1-1.8-18.5-5-27-.1-.3 0-.5.3-.6.3-.1.5 0 .6.3 3.3 8.6 4.2 18.1 5.1 27.2 1.1 11.1 2.2 22.6 7.6 32.4.1.2 0 .5-.2.7-.1.1-.1.1-.2.1z",
              },
            }),
            _c("path", {
              staticClass: "st16",
              attrs: {
                d: "M978.3 861.6c.7.7 1.8.9 2.7.6s1.8-.8 2.6-1.4c2.4-1.8 4.7-3.8 6.1-6.5.4-.7.7-1.6.3-2.4-.3-.8-2.5-1.1-3-1-.5.1-.9.4-1.2.7-1.8 1.5-3.6 2.9-5.4 4.4-.9.7-1.8 1.4-2.3 2.5-.5.9-.6 2.3.2 3.1z",
              },
            }),
            _c("path", {
              staticClass: "st16",
              attrs: {
                d: "M982.5 865c.7.7 1.8.9 2.7.6 1-.3 1.8-.8 2.6-1.4 2.4-1.8 4.7-3.8 6.1-6.5.4-.7.7-1.6.3-2.4-.3-.8-2.5-1.1-3-1-.5.1-.9.4-1.2.7-1.8 1.5-3.6 2.9-5.4 4.4-.9.7-1.8 1.4-2.3 2.5-.5 1-.6 2.3.2 3.1z",
              },
            }),
            _c("path", {
              staticClass: "st16",
              attrs: {
                d: "M988.3 868.2c.7.6 1.7.5 2.6.2.8-.4 1.5-1 2.1-1.7 1.9-2 3.7-4.1 4.5-6.7.2-.7.4-1.6-.1-2.2-.4-.6-2.4-.6-2.8-.5s-.7.5-1 .8l-4.2 4.8c-.7.8-1.4 1.6-1.7 2.5-.4.9-.2 2.1.6 2.8z",
              },
            }),
            _c("path", {
              staticClass: "st16",
              attrs: {
                d: "M992.7 869.3c.6.5 1.5.5 2.2.1.7-.3 1.3-.9 1.8-1.5 1.7-1.7 3.2-3.6 4-5.9.2-.6.3-1.4-.1-1.9-.4-.6-2.1-.5-2.5-.4-.4.1-.6.4-.9.7-1.2 1.4-2.5 2.8-3.7 4.2-.6.7-1.2 1.4-1.5 2.2-.1.9 0 2 .7 2.5z",
              },
            }),
            _c("path", {
              staticStyle: {
                opacity: ".51",
                fill: "#fff",
                "enable-background": "new",
              },
              attrs: {
                id: "texture-3_9_-i2",
                d: "M1069.7 889.4c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2c.2-.1.3 0 .2.2zm-5-1c0 .1-.1.2-.3.2-.1 0-.2-.1-.2-.3 0-.1.1-.2.2-.2.2.1.3.2.3.3zm-6.8 18.9c.1.1 0 .2-.1.3-.1.1-.2 0-.3 0-.1-.1 0-.2 0-.3.2-.1.3-.1.4 0zm9-28.7c0 .1 0 .2-.2.2-.1 0-.2 0-.2-.2 0-.1 0-.2.2-.2l.2.2zm-3.6 19.2c.1.1.1.2.1.3-.1.1-.2.1-.3.1-.1-.1-.1-.2-.1-.3.1-.1.2-.1.3-.1zm-4.3-2.8c.1.1.1.2 0 .3-.1.1-.2.1-.3.1-.1-.1-.1-.2-.1-.3.2-.1.3-.1.4-.1zm27.2-28.3c.1.2-.1.4-.3.5-.2.1-.4-.1-.5-.3-.1-.2.1-.4.3-.5.2-.1.4.1.5.3zm-9.4 2.6c.1.2-.1.4-.3.5-.2.1-.4-.1-.5-.3-.1-.2.1-.4.3-.5.2 0 .4.1.5.3zm13.7 35.2c.2.1.3.4.1.6-.1.2-.3.3-.5.2-.2-.1-.3-.4-.1-.6 0-.3.3-.3.5-.2zm-8.5-4.8c.2.1.3.4.2.5-.1.2-.4.3-.5.2-.2-.1-.3-.3-.2-.5.1-.2.3-.3.5-.2zm-8.5-4.7c.2.1.3.3.2.5-.1.2-.3.3-.5.2-.2-.1-.3-.4-.2-.6.1-.2.3-.3.5-.1zm-8.5-4.8c.2.1.3.4.1.6-.1.2-.4.3-.6.1-.2-.1-.3-.3-.2-.5.3-.2.5-.3.7-.2zm9.6-36.4c.1.2.1.4-.1.6-.2.1-.4.1-.6-.1-.1-.2-.1-.4.1-.6.2-.1.5-.1.6.1zm18.1 30c0 .2-.2.4-.5.3-.2 0-.4-.2-.3-.5 0-.2.2-.4.4-.3.3.1.4.3.4.5zm-9.7-1.2c0 .2-.2.4-.5.3-.2 0-.4-.2-.3-.5 0-.2.2-.4.4-.3.3.1.5.3.4.5zm-9.6-1.1c0 .2-.2.4-.5.3-.2 0-.4-.2-.3-.4 0-.2.2-.4.4-.4.2.1.4.3.4.5zm1.3 34.6c.1.2.1.4-.1.6-.2.1-.4.1-.6-.1-.1-.2-.1-.4 0-.5.3-.2.5-.1.7 0zm-6.1-7.6c.1.2.1.4-.1.6-.2.1-.4.1-.6-.1-.1-.2-.1-.4.1-.6.3-.1.5-.1.6.1zm-6-7.7c.1.2.1.4 0 .5-.2.1-.4.1-.6 0-.1-.2-.1-.4.1-.6.1-.1.4 0 .5.1zm31-26.5c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4.4.2.4.4zm-8.7-.2c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4.4.2.4.4zm-8.8-.4c.1.1.1.1.1.2 0 .2-.2.4-.4.4s-.4-.2-.4-.4c0-.1.1-.2.2-.3.1 0 .1-.1.2 0 .1-.1.2 0 .3.1zm-8.6 0c0 .2-.2.4-.4.4s-.4-.2-.3-.4c0-.2.2-.4.4-.4s.3.2.3.4zm11.2 33.8c.1.2.1.4 0 .5-.1.1-.4.1-.5 0-.1-.1-.1-.4 0-.5.1-.2.4-.2.5 0zm-6-6.3c.1.1.1.4 0 .5-.1.1-.4.1-.5 0-.1-.1-.1-.4 0-.5.2-.1.4-.1.5 0zm-6-6.3c.1.1.1.4 0 .5-.1.1-.3.1-.5 0-.1-.1-.1-.4 0-.5.2-.1.4-.1.5 0zm11.5-35.1c.1.2 0 .4-.2.5-.2.1-.4 0-.4-.2-.1-.2 0-.4.2-.5.1 0 .3.1.4.2zm7.4 29.9c.2.1.3.3.2.5-.1.2-.3.3-.5.2-.2-.1-.3-.3-.2-.5.1-.2.3-.2.5-.2zm-7.9-3.5c.2.1.3.3.2.4-.1.2-.3.3-.5.2-.2-.1-.3-.3-.2-.5.1-.1.3-.1.5-.1zm-8-3.5c.2.1.3.3.2.5-.1.2-.3.3-.5.2-.2-.1-.3-.3-.2-.5.1-.2.3-.2.5-.2zm-7.7 30.4c.1.2 0 .4-.2.4-.2.1-.4 0-.5-.2-.1-.2 0-.4.2-.5.2 0 .4.1.5.3zm-3.2-8.1c.1.2 0 .4-.2.5-.2.1-.4 0-.5-.2-.1-.2 0-.4.2-.5.2-.1.4 0 .5.2zm16.5-42.1c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2c0 .1.1.1.2.2zm-4.9 20.9c.1.1.1.2 0 .3-.1.1-.2.1-.3 0-.1-.1-.1-.2 0-.3h.3zm-4.2-2.9c.1.1.1.2 0 .3-.1.1-.2.1-.3 0-.1-.1-.1-.2-.1-.3.2-.1.3-.1.4 0zm6.1-7.7c0 .1-.1.2-.3.2-.1 0-.2-.1-.2-.2s.1-.2.2-.2c.3 0 .4.1.3.2zm-11.2 15.9c.1.1 0 .2-.1.3-.1.1-.2 0-.3-.1-.1-.1 0-.2 0-.3.2 0 .3 0 .4.1zm20.4-26.4c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2c.1-.1.2.1.2.2zm-5.8-.1c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2.2.1.2.2zm-3.9 22.5c.1.1.1.2 0 .3-.1.1-.2.1-.3 0-.1-.1-.1-.2 0-.3 0-.1.2-.1.3 0zm-4.1-4.2c.1.1.1.3 0 .3-.1.1-.2.1-.3 0-.1-.1-.1-.2 0-.3 0-.1.2 0 .3 0zm8.5-29.7c.1.1 0 .3-.1.3s-.3 0-.3-.1 0-.3.1-.3c.1-.1.2 0 .3.1zm-.1 22.5v.1c0 .1-.2.2-.3.1-.1-.1-.2-.2-.1-.3 0-.1.2-.2.3-.1.1 0 .1.1.1.2zm-5.5-2.6c.1 0 .2.2.1.3-.1.1-.2.2-.3.1-.1-.1-.2-.2-.1-.3 0-.1.2-.1.3-.1zm30.8 8.1c.2.1.3.3.2.6-.1.2-.3.3-.5.2-.2-.1-.3-.3-.2-.6 0-.2.2-.3.5-.2zm-9.2-4.1c.2.1.3.3.2.5-.1.2-.3.3-.5.2-.2-.1-.3-.3-.2-.5.1-.2.3-.3.5-.2zm-9.1-4.2c.2.1.3.3.2.6-.1.2-.3.3-.6.2-.2-.1-.3-.3-.2-.6.2-.2.4-.3.6-.2zm-9.1-4.1c.2.1.3.3.2.5-.1.2-.3.3-.5.2-.2-.1-.3-.3-.2-.5 0-.2.3-.3.5-.2zm-3.2 41.5c.1.2 0 .5-.2.5-.2.1-.5 0-.5-.3-.1-.2 0-.4.2-.5.2 0 .4.1.5.3zm-3.6-9.4c.1.2 0 .5-.2.5-.2.1-.5 0-.5-.2-.1-.2 0-.5.2-.5.2-.1.5 0 .5.2zm-3.5-9.4c.1.2 0 .5-.2.5-.2.1-.5 0-.5-.2-.1-.2 0-.5.3-.5.1-.1.3 0 .4.2zm18.2-32.1c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4.4.2.4.4zm4.4 35.5c.1.2.1.4 0 .6-.2.1-.4.1-.6 0-.2-.2-.2-.4 0-.6.1-.2.4-.2.6 0zm-6.9-7.3c.2.2.1.4 0 .6-.2.2-.4.1-.6 0-.2-.2-.2-.4 0-.6.2-.2.4-.2.6 0zm-6.9-7.4c.2.2.2.4 0 .6-.2.2-.4.2-.6 0-.2-.2-.2-.4 0-.6.2-.1.5-.1.6 0zm5.7-27.1c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4.4.2.4.4zm14.1 38.5c.2.2.2.4 0 .6s-.4.2-.6 0c-.2-.2-.2-.4 0-.6.2-.2.4-.2.6 0zm-7.1-7c.2.2.2.4 0 .6-.2.2-.4.2-.6 0-.2-.2-.2-.4 0-.6.1-.2.4-.2.6 0zm-7.2-7c.2.2.2.4 0 .6-.2.2-.4.2-.6 0-.2-.2-.2-.4 0-.6.2-.2.5-.2.6 0zm-7.1-7c.2.1.2.4 0 .6-.2.2-.4.2-.6 0-.2-.2-.2-.4 0-.6.2-.2.4-.2.6 0zm18.9-3.2c.2.1.3.3.2.5-.1.2-.3.3-.5.2-.2-.1-.3-.3-.2-.5 0-.2.3-.3.5-.2zm-9.3-3.7c.2.1.3.3.2.5-.1.2-.3.3-.5.2-.2-.1-.3-.3-.2-.5.1-.2.3-.3.5-.2zm-7.8 35.2c.1.2 0 .5-.2.5-.2.1-.4 0-.5-.2-.1-.2 0-.4.2-.5.2-.2.4-.1.5.2 0-.1 0 0 0 0zm-3.9-9.2c.1.2 0 .5-.2.5-.2.1-.4 0-.5-.2-.1-.2 0-.4.2-.5.2-.1.4-.1.5.2zm9-7.4c.1.1.1.3-.1.4-.1.1-.3.1-.4-.1-.1-.1-.1-.3.1-.4.1-.1.3-.1.4.1zm-4.2-6.3c.1.1.1.3-.1.4-.1.1-.3.1-.4-.1-.1-.1-.1-.3.1-.4.1-.1.3 0 .4.1zm-4.1-6.3c.1.1.1.3-.1.4-.1.1-.3.1-.4-.1-.1-.1-.1-.3.1-.4.1-.1.3 0 .4.1zm16.4-1.2c.1.1.2.3.1.4-.1.1-.3.2-.4.1-.1-.1-.2-.3-.1-.4.1-.1.2-.2.4-.1zm-6.2-4.2c.1.1.2.3.1.4-.1.1-.3.2-.4.1-.1-.1-.2-.3-.1-.4 0-.2.2-.2.4-.1zm-6.3-4.2c.1.1.2.3.1.4-.1.1-.3.2-.4.1-.1-.1-.2-.3-.1-.4.1-.2.3-.2.4-.1zm-.3-2.3c.1.1.1.2 0 .2-.1.1-.2.1-.2 0-.1-.1-.1-.2 0-.2h.2zm2.9 7.7c.1.1 0 .3-.1.4-.1.1-.3 0-.3-.1-.1-.1 0-.3.1-.4 0-.1.2-.1.3.1zm-2.9-6.2c.1.1 0 .3-.1.4-.1.1-.3 0-.4-.1-.1-.1 0-.3.1-.4.2-.1.4-.1.4.1z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_21_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "211.887",
                  y1: "808.176",
                  x2: "233.409",
                  y2: "751.906",
                  gradientTransform: "matrix(1.0348 0 0 1.0356 907.57 -3.462)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#ffbeb6" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#f2a19c" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_21_)" },
              attrs: {
                d: "M1184.3 836.9c-2.6-2.8-9.1-7.7-11.8-10.5-3.3-3.4-19.4-43.1-28.1-58.1-1.5-2.5-3-5.1-5.1-7.2-1.4-1.4-3.1-2.5-4.7-3.6-8.1-5.5-16.3-10.9-24.4-16.4-2.9-2-6-4-9.5-4.2-3.5-.2-7.4 2-7.7 5.6-.2 3 2.1 5.4 4.3 7.5 5.2 5 10.5 10 15.7 14.9 4 3.8 8.1 7.7 10.9 12.4 3 5 4.4 10.8 7.3 15.8 4.6 8.1 17.7 18.1 24.2 24.8 6.5 6.7 8.8 12.3 5.1 20.5-3.2 7.1-2.5 12-2.5 18.8 0 3.1 4.8-.3 5.6-3.3 1.5-5.6 1.4-6.7 2.9-12.2.3.1.6.2.8.3.5 3.4 1.4 6.7 2.6 9.9.7 1.8 1.5 3.7 1.3 5.7 0 .4-.1.9 0 1.3.2 1.1 1.5 1.6 2.6 1.4.6-.1 1.2-.4 1.7-.8 2.8-.9 14.6-9.7 14.9-11.6.3-3.7-1.4-6-6.1-11z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_22_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "4813.51",
                  y1: "2544.251",
                  x2: "5146.14",
                  y2: "2356.993",
                  gradientTransform: "matrix(.1376 0 0 .1377 408.566 409.746)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#008ec6" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#009bd3" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_22_)" },
              attrs: {
                d: "M1057.7 712.1c2-5 6-3.9 11-2s11.2 4.8 15.5 8.1c16.5 12.8 35.6 22 54.4 31.1-8.4 11.4-14.1 24.8-15.5 39-9.2-17.2-22-31.9-37.9-43.3-6.3-4.5-13.3-3.7-19-9-5.7-5.5-11.4-16.7-8.5-23.9z",
              },
            }),
          ],
          1
        ),
      ]),
      _c("g", [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_23_", d: "M374 635h195v488H374z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_24_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_23_" },
          }),
        ]),
        _c(
          "g",
          { staticStyle: { "clip-path": "url(#SVGID_24_)" } },
          [
            _c("path", {
              staticClass: "st27",
              attrs: {
                d: "M404.5 1102.1c3.5.8 6.9 1.6 10.4 2.5 15.7 3.7 32.2 7.5 47.9 3.6 1.9-.5 4-1.3 4.8-3.1 1.1-2.5-1.2-5.3-3.8-6.1-2.6-.7-5.4-.1-8 .1-9.2.8-18.5-3.2-25.2-9.6-6.7-6.4-10.9-15.1-13.3-24-5.2 2.3-7.6 8.3-9.5 13.7-2 5.6-4 11.3-5.9 16.9-.6 1.6-1.1 3.5.1 4.8.6.7 1.5 1 2.5 1.2z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_25_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "404.408",
                  y1: "950.785",
                  x2: "510.295",
                  y2: "950.785",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#1A7BEE" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#009bd3" },
                  attrs: { offset: ".37" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#008ec6" },
                  attrs: { offset: ".999" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_25_)" },
              attrs: {
                d: "M508.7 850.8c8.7 23.3-22.1 104.6-29.8 128.5-10 31.1-29.4 58.8-38.8 90.5-2.2 7.4-2.1 15.9-3.2 23.3-.5 3.7-9.2 3.2-17.7-.2-12.6-5-7.3-19.3-6.8-32.2 1.3-30.3 13.6-60.7 6.9-89.9-4.5-19.5-11.8-39.4-13.7-59.2-1.9-19.3-3.4-57.6 9.8-73 30.8-35.7 80-55.5 93.3 12.2z",
              },
            }),
            _c("path", {
              staticClass: "st17",
              attrs: {
                d: "M529.1 671.5c2.8-4.3 7.6-14.4 4.3-18.4-4.2-.1-10-.4-14.2.2-5.1.4 3.4 13.4-.5 18.2-3.4 4.2-7.3 8.2-9.3 13.4 7.7-3.5 12.3-10.1 19.7-13.4z",
              },
            }),
            _c("path", {
              staticClass: "st13",
              attrs: {
                d: "M509.7 672.9c-.9 0-1.7-.5-2.2-1.3-.7-1.2-.3-2.8.9-3.5l50.5-29.6c1.2-.7 2.8-.3 3.5.9.7 1.2.3 2.8-.9 3.5L511 672.5c-.5.3-.9.4-1.3.4z",
              },
            }),
            _c("path", {
              staticClass: "st16",
              attrs: {
                d: "M514.8 700.1c-1-5.6-1-11.8 3.2-15.4 5-4.1 8.3-5.2 12.4-10.4 1.7-1.8-.2-13.5-2.4-19.3-1.1-1.6-2.7-2.3-4.9-.6-1.4 1.1-5.8 4.9-6.8 6.4-3.3 4.6.1 6 1.1 9.5 2.8.4 4.8-.7 4-5.4-.2-1.6.7-3.1 2.6-3.1.2 1.4 1.1 4-.1 5.5-4.6 5.6-16.6 11.9-20 16-7.1 8.6.3 15.4 1.1 25.2 3-1.8 6.9-2.3 9.7-4.6-.5-1.4.5-2 .1-3.8z",
              },
            }),
            _c("path", {
              staticClass: "st13",
              attrs: {
                d: "M398.1 1115.3c3.5.8 6.9 1.6 10.4 2.5 15.7 3.7 32.2 7.5 47.9 3.6 1.9-.5 4-1.3 4.8-3.1 1.1-2.5-1.2-5.3-3.8-6.1s-5.4-.1-8 .1c-9.2.8-18.5-3.2-25.2-9.6s-10.9-15.1-13.3-24c-5.2 2.3-7.6 8.3-9.5 13.7-2 5.6-4 11.3-5.9 16.9-.6 1.6-1.1 3.5.1 4.8.6.7 1.6 1 2.5 1.2z",
              },
            }),
            _c("path", {
              staticClass: "st27",
              attrs: {
                d: "M510.5 810.7c-6.1-2-9-8.8-11.2-14.8-4.1-11.3-8.2-22.9-7.8-34.8.5-13.7 7-26.5 9.2-40 1.4-9 .9-18.2-1.5-27 5.4.6 10.9.1 16.1-1.3 2.1 16.3 12.8 30.1 18.8 45.4 3.9 9.9 5.7 20.5 5.5 31.1-.2 12.5-3.7 25.4-11.9 34.7-4.3 4.8-11 8.8-17.2 6.7z",
              },
            }),
            _c("path", {
              staticStyle: { fill: "#1A7BEE" },
              attrs: {
                d: "M419 1097.6c-5.5-28 .8-60.6 20.7-82.1 5.3-5.7 15.4-19.5 20.5-25.5 7.7-9 12.3-21.4 15.3-28.6 10.2-24.3 22.7-47.6 35.1-109.2.3-1.7 8.8-34.4 7.1-34.5-15.5-1.1-31.8-4.3-34.1-4.5-33.7-2-39.7 5.1-73.1 9.9-4.5.6-9.7 1.7-11.8 5.8-5.6 20.7-9.3 42-11.1 63.4-1.4 16.8-1.7 33.9 2.6 50.2 3.1 11.8 8.5 22.9 11.6 34.7s-1.3 19.1-5.8 36.4c-2.1 8.2-16.6 32.6-3.2 84.4 4.7 3.6 21.7 2.5 26.2-.4z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_26_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "48.313",
                  y1: "995.057",
                  x2: "48.313",
                  y2: "1105.87",
                  gradientTransform:
                    "matrix(1.1677 0 0 -1.1702 400.827 2028.995)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#23286b" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#151a4f" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_26_)" },
              attrs: {
                d: "M423.2 710.9c-24.3 32.2-40.7 70.3-47.5 110.1-1.6 9.5-2.7 19.4-.3 28.8 52 19.7 111.9 17.6 162.5-5.7 9.3-43.5-6.2-91.5-39.1-121.4-15.2-13.8-35.7-24.1-55.8-20.1-12.9 2.5-12-2.1-19.8 8.3z",
              },
            }),
            _c("path", {
              staticClass: "st8",
              attrs: { d: "m563.5 780.3-50.4 19.4-25.9-67.5 50.4-19.4z" },
            }),
            _c("path", {
              staticClass: "st29",
              attrs: {
                d: "M417.4 650.1c3.5-1.6 4.1-7 1.6-9.9-2.5-3-7-3.6-10.7-2.5-3.7 1.2-6.7 3.8-9.3 6.7-2.5 2.7-4.8 5.7-5.8 9.2-1 3.5-.5 7.7 2.1 10.3 3.6 3.7 10.1 3 14.3-.2 4.1-3.2 6.5-8.1 8.7-12.8 1.6 3.7-2.6-4.6-.9-.8z",
              },
            }),
            _c("path", {
              staticClass: "st17",
              attrs: {
                d: "M449.4 701.4c0 .7-.1 1.4-.4 2-.7 1.5-2.6 1.9-4.3 2.1-8.6.7-17.3-1.6-24.4-6.5 1.2-7.2 1.1-14.6-.5-21.8 3.1 1.8 7 1.4 10.6 1 6.7-.8 13.3-1.6 20-2.4-.3 8.5-.7 17-1 25.6z",
              },
            }),
            _c("path", {
              staticClass: "st16",
              attrs: {
                d: "M410.8 667c.2-1.7.6-3.3.9-5 .4-1.7.8-3.4 1.2-5.2.4-1.9.9-3.8 2-5.4 1.4-2 3.7-3.3 6-4.1 7.8-2.8 17-1.2 23.5 4s10 13.8 9 22.1c-.2 1.8-.6 3.6-1.3 5.2-1.2 2.8-3.1 5.3-5.4 7.3-6.6 5.6-16.7 6.7-24.3 2.7s-12.5-12.9-11.6-21.6z",
              },
            }),
            _c("path", {
              staticClass: "st13",
              attrs: {
                d: "M427.9 677.3c-5.7 0-10.4-4.7-10.4-10.4s4.7-10.4 10.4-10.4 10.4 4.7 10.4 10.4-4.7 10.4-10.4 10.4zm0-19.1c-4.8 0-8.7 3.9-8.7 8.7s3.9 8.7 8.7 8.7c4.8 0 8.7-3.9 8.7-8.7s-3.9-8.7-8.7-8.7zM447.8 667.7c-5.7 0-10.4-4.7-10.4-10.4 0-5.8 4.7-10.4 10.4-10.4s10.4 4.7 10.4 10.4-4.7 10.4-10.4 10.4zm0-19.1c-4.8 0-8.7 3.9-8.7 8.7s3.9 8.7 8.7 8.7c4.8 0 8.7-3.9 8.7-8.7s-4-8.7-8.7-8.7z",
              },
            }),
            _c("path", {
              staticClass: "st29",
              attrs: {
                d: "M404.2 688.6c-2 0-3.9-.3-5.7-1-.3-.1-.5-.4-.4-.7.1-.3.4-.5.7-.4 4.1 1.5 8.9 1.1 13.1-.9 4.3-2 7.6-5.6 9-9.6 1-3 1.3-6.2 1.5-9.3.1-1.7.2-3.5.5-5.2.5-3.3 1.5-6.5 2.9-9.5.9-2 2.4-4.5 4.2-5.4.3-.1.6 0 .8.3.1.3 0 .6-.3.8-1.1.6-2.4 2.3-3.6 4.8-1.4 2.9-2.3 6-2.8 9.2-.3 1.7-.4 3.4-.5 5.1-.2 3.2-.5 6.5-1.6 9.6-1.5 4.4-5 8.1-9.6 10.3-2.6 1.3-5.4 1.9-8.2 1.9z",
              },
            }),
            _c("path", {
              staticClass: "st29",
              attrs: {
                d: "M407.8 650.2c3.4-3.5 10.3-5.8 15.2-5.7 4.9 0 10.9 1.3 14.1 2.9-8.8 1.2-16.7 5-19.7 13.4-1.7 4.7-1.6 12.2-3.4 16.8-1.8 4.6-7.6 8.7-12.6 8.1 2.8-5.4 2.2-11.9 1.9-18.1-.2-6.2.2-13 4.5-17.4z",
              },
            }),
            _c("path", {
              staticClass: "st16",
              attrs: {
                d: "M536.9 741.8c7.5-4.5 1.8-15.6 3.5-17.1 4.1-3.6 5 2.6 5.9 7.4.2 1.2.9 3.8 1.2 4 4 2.3 16.2 4.4 14.1 8.6-.5 1.1-2.4 1.9-2.7 3-1.2 4.6.5 9.8-2.8 14-5.8-7.3-17.1-.5-25.3-3.2.9-3.7 1.2-9.4 2.4-13.6.2-.6 1.5-3 1.3-2.4l2.4-.7z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_27_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "11.067",
                  y1: "1082.487",
                  x2: "97.979",
                  y2: "1123.77",
                  gradientTransform:
                    "matrix(1.1677 0 0 -1.1702 400.827 2028.995)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#23286b" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#151a4f" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_27_)" },
              attrs: {
                d: "M455.7 786.2c-17.9-4.3-37-9.4-48.8-23.5-4.6-5.5-7.8-12.2-10.3-18.9-3.4-9.2-5.6-19.4-2.2-28.6 5.6-15.2 25-21.6 40.6-17.4 15.6 4.1 28 15.9 38.6 28.1 4.7 5.5 9.6 12.7 6.8 19.4 18.4-9.6 40.2-8.3 57-3.6 2.7 7 1.8 16.2.5 18-.3.5-3.7 3-5.9 4-13.4 6.3-23 19.5-37 24.4-12.7 4.3-26.4 1.2-39.3-1.9z",
              },
            }),
            _c("path", {
              staticClass: "st13",
              attrs: {
                d: "M433.8 659.9c-.1 0-.3 0-.4-.1-.4-.2-.6-.8-.3-1.2.1-.3.3-.5.4-.8.7-1.5 1.8-3.8 5-2.9.5.1.8.6.6 1.1-.1.5-.6.7-1.1.6-1.7-.4-2.2.4-3 2-.2.3-.3.6-.5.9-.1.2-.4.4-.7.4z",
              },
            }),
            _c("path", {
              staticClass: "st29",
              attrs: {
                d: "M556.9 639.8c.6 1.1 1.2 2.4 2 3.4.7.9.8.8.8.8s2.3-1.3 2.6-1.6c2.4-1.7 3.4-2.9 5.3-4.8.9-.9 1.9-2.9 0-2.6-1 .1-2.2.3-3.1.7-2.4.9-4.6 2.3-6.9 3.5-.4.2-.7.4-.7.6z",
              },
            }),
            _c("path", {
              staticClass: "st4",
              attrs: {
                id: "texture-2_9_-i3",
                d: "M395.3 898.3c.1-.1 0-.3-.1-.4-.1-.1-.3 0-.4.1-.1.1 0 .3.1.4.1.1.3.1.4-.1zm3.5-29.4c.2 0 .3-.2.2-.4 0-.1-.2-.2-.3-.2-.2 0-.2.2-.2.3 0 .3.1.4.3.3zm-2.7 14.8c.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3-.2 0-.3.1-.3.3 0 .1.1.3.3.3zm34.4 17.2c.3.1.6-.1.6-.4.1-.3-.1-.6-.4-.6-.3-.1-.6.1-.6.4-.1.3.1.6.4.6zm-13.1-2.5c.3.1.6-.2.6-.5.1-.3-.1-.6-.4-.6-.3-.1-.6.1-.6.4-.1.3.1.6.4.7zm-13.2-2.6c.3.1.6-.1.6-.4.1-.3-.1-.6-.4-.6-.3 0-.6.1-.7.4 0 .3.2.6.5.6zm10.2 28.8c.2-.3.1-.6-.2-.8-.3-.2-.6-.1-.8.2-.2.3-.1.6.2.7.3.3.6.2.8-.1zm-11.2-7.4c.2-.3.1-.6-.2-.8-.3-.2-.6-.1-.8.2-.2.3-.1.6.2.7.3.3.7.2.8-.1zm21.1-42.6c.3-.1.5-.4.4-.7-.1-.3-.3-.5-.6-.4-.3 0-.5.3-.5.6.1.4.4.5.7.5zm-13.2 2.7c.3-.1.5-.4.4-.7-.1-.3-.4-.5-.7-.4-.3.1-.5.4-.4.7.2.2.4.4.7.4zm-13.1 2.6c.3-.1.5-.3.4-.6 0-.3-.3-.5-.6-.5-.3.1-.5.4-.4.7 0 .3.3.5.6.4zm8.9 55.5c.2-.2.1-.5-.1-.7-.2-.2-.5-.1-.7.1-.2.2-.1.5.1.7.2.1.5.1.7-.1zm13.9-48.1c.3 0 .5-.3.4-.6 0-.3-.3-.5-.5-.4-.3 0-.5.3-.4.5 0 .3.2.5.5.5zm-11.9 1.2c.3 0 .5-.3.4-.5 0-.3-.3-.5-.5-.4-.3 0-.5.3-.4.5 0 .3.3.5.5.4zm-11.9 1.3c.3 0 .5-.3.4-.5 0-.3-.2-.4-.5-.4s-.5.3-.4.5c0 .2.3.4.5.4zm15.3 22.3c.3.1.5-.1.6-.3.1-.3-.1-.5-.3-.6-.3-.1-.5.1-.6.3-.2.2 0 .5.3.6zm-11.5-3.4c.2.1.5-.1.6-.3.1-.3-.1-.5-.3-.6-.3-.1-.5.1-.6.3-.1.2.1.5.3.6zm7.4-42.2c.2-.1.3-.4.2-.6-.1-.2-.4-.3-.7-.2-.2.1-.3.4-.2.7.2.1.5.2.7.1zm-10.5 5.7c.2-.1.3-.4.2-.7-.1-.2-.4-.3-.7-.2-.2.1-.3.4-.2.7.2.2.5.3.7.2zm21.7 65c.3.1.6-.1.7-.4.1-.3-.1-.6-.4-.7-.3-.1-.6.1-.7.4-.1.3.1.6.4.7zm-13.2-3.8c.3.1.6-.1.7-.4.1-.3-.1-.6-.4-.7-.3-.1-.6.1-.7.4-.1.3.1.6.4.7zm7-54c.3-.2.4-.5.2-.8-.2-.3-.5-.4-.8-.2-.3.2-.4.5-.2.8.2.2.5.3.8.2zm-12 6.7c.3-.2.4-.5.2-.8-.2-.3-.5-.4-.8-.2-.3.2-.4.5-.2.8.1.2.5.3.8.2zm14.5 23.3c.3-.1.5-.3.5-.6s-.3-.5-.6-.5-.5.3-.5.6.3.5.6.5zm-13.7 1.5c.3 0 .5-.3.5-.6s-.3-.5-.6-.5-.5.3-.5.6.3.6.6.5zm17.1 7.3c.3 0 .5-.3.5-.6s-.3-.5-.6-.5-.5.3-.5.6.3.5.6.5zm-13.7 1c.3 0 .6-.3.5-.6 0-.3-.3-.5-.6-.5s-.6.3-.5.6c0 .3.3.5.6.5zm-.3-26.1c.3-.1.4-.5.2-.8-.1-.3-.5-.4-.8-.2-.3.1-.4.5-.3.7.2.3.6.4.9.3z",
              },
            }),
            _c("path", {
              staticClass: "st13",
              attrs: {
                d: "M567.6 635c-1 .1-2.2.3-3.1.7-.2.1-.4.2-.6.2l1.9 3.5 1.8-1.8c1-.8 2-2.9 0-2.6z",
              },
            }),
          ],
          1
        ),
      ]),
      _c("g", [
        _c("defs", [
          _c("path", { attrs: { id: "SVGID_28_", d: "M210 52h220v358H210z" } }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_29_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_28_" },
          }),
        ]),
        _c(
          "g",
          { staticStyle: { "clip-path": "url(#SVGID_29_)" } },
          [
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "L_shoe-i4_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "3685.264",
                  y1: "-4965.743",
                  x2: "2809.419",
                  y2: "-5085.175",
                  gradientTransform:
                    "matrix(-.06654 0 0 -.06632 466.377 61.265)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#a1c3fc" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#a1e7fc" },
                  attrs: { offset: ".696" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#a1e7fc" },
                  attrs: { offset: ".844" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#009bd3" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#L_shoe-i4_1_)" },
              attrs: {
                id: "L_shoe-i4",
                d: "m280.5 377.7 11.6 32.3h-82.2s4.2-8.1 18.3-14.1c14-6 27.1-18.2 27.1-18.2h25.2",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "R_shoe-i4_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "2577.209",
                  y1: "-5018.897",
                  x2: "954.908",
                  y2: "-5297.574",
                  gradientTransform:
                    "matrix(-.06654 0 0 -.06632 466.377 61.265)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#a1c3fc" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#a1e7fc" },
                  attrs: { offset: ".696" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#009bd3" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#R_shoe-i4_1_)" },
              attrs: {
                id: "R_shoe-i4",
                d: "m328.7 377.7 11.6 32.3h-82.2s4.2-8.1 18.3-14.1c14-6 25.4-18.2 25.4-18.2h26.9",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "L_trousers-i4_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "4227.42",
                  y1: "-4637.99",
                  x2: "2532.634",
                  y2: "-3341.222",
                  gradientTransform:
                    "matrix(-.06654 0 0 -.06632 466.377 61.265)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#008ec6" },
                  attrs: { offset: ".129" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#009bd3" },
                  attrs: { offset: ".999" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#L_trousers-i4_1_)" },
              attrs: {
                id: "L_trousers-i4",
                d: "M282.3 231c24.3-2.5 62.8-3.7 62.8-3.7l56.8 9.9s11.7 26-34.8 28.4c-22.2 1.1-69.6 10.5-80.9 5.8-2.1-.9-4.5.1-5.4 2.2-.2.6-.4 1.2-.3 1.8.2 4.4.3 6.7 6.6 23.8 9.6 25.9 3.2 61.1-6.5 78.6h-25.1c-1.3-7.1-17.1-103.1-17.6-118.6-.9-24.5 27.3-26.4 44.4-28.2z",
              },
            }),
            _c("path", {
              staticClass: "st6",
              attrs: {
                id: "R_trousers-i4",
                d: "M416 217.5s18.9 42.7-25.9 55.3c-21.3 6-67.2 5.6-79.3 3.5-2.2-.4-4.4 1.1-4.8 3.3-.1.6-.1 1.2.1 1.8 1.2 4.3 1.8 6.5 11.7 21.8 17.1 26.2 20 54.7 10.9 74.5h-26.8s-38.6-90.9-44.6-105.9c-8.5-21.3 10.1-31.4 34-36.2 23.9-4.9 67.1-15.1 67.1-15.1l57.6-3",
              },
            }),
            _c("path", {
              staticStyle: {
                opacity: ".86",
                fill: "#fff",
                "enable-background": "new",
              },
              attrs: {
                id: "texture-3-i4",
                d: "M390.2 246.1c-.1 0-.2 0-.2-.1s0-.2.1-.2.2 0 .2.1c0 0 0 .1-.1.2zm-1.6-4c-.1 0-.2 0-.2-.1s0-.2.1-.2.2 0 .2.1-.1.2-.1.2zm-16.4 3.9c0 .1-.1.1-.2.1s-.1-.1-.1-.2.1-.1.2-.1.1.1.1.2zm24.2-6.8c-.1.1-.2.1-.2 0-.1-.1-.1-.2 0-.2.1-.1.2-.1.2 0 .1 0 .1.1 0 .2zm-15.1 6.3c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2.2.1.2.2zm32.3 1.6c-.1.1-.3.2-.5 0-.1-.1-.2-.3 0-.5.1-.1.3-.2.5 0 .1.2.2.4 0 .5zm-6.1-5.3c-.1.1-.3.2-.5 0-.1-.1-.2-.3 0-.5.1-.1.3-.2.5 0 .1.2.1.4 0 .5zm-18.3 25.6c0 .2-.1.3-.3.4-.2 0-.3-.1-.4-.3 0-.2.1-.3.3-.4.2 0 .4.2.4.3zm-.6-8c0 .2-.1.3-.3.4-.2 0-.3-.1-.4-.3 0-.2.1-.3.3-.4.2-.1.4.1.4.3zm-.6-8.1c0 .2-.1.3-.3.4-.2 0-.3-.1-.4-.3 0-.2.1-.3.3-.4.3 0 .4.1.4.3zm-.5-8.1c0 .2-.1.3-.3.4-.2 0-.3-.1-.4-.3 0-.2.1-.3.3-.4.2 0 .3.1.4.3zm29.9-10c-.1.2-.3.3-.4.2-.2-.1-.3-.3-.2-.4.1-.2.3-.3.4-.2.1 0 .2.2.2.4zm-12.7 26.3c-.2.1-.4 0-.4-.2-.1-.2 0-.4.2-.4.2-.1.4 0 .4.2 0 .1-.1.3-.2.4zm-3.7-7.2c-.2.1-.4 0-.4-.2-.1-.2 0-.4.2-.4.2-.1.4 0 .4.2.1.1 0 .3-.2.4zm-3.6-7.3c-.2.1-.4 0-.5-.2-.1-.2 0-.4.2-.4.2-.1.4 0 .5.1 0 .2 0 .4-.2.5zm-23.7 16.8c-.1.2-.3.3-.4.2-.2-.1-.3-.2-.2-.4 0-.2.2-.3.4-.2.2 0 .3.2.2.4zm2.6-7.7c-.1.2-.3.3-.4.2-.2-.1-.3-.3-.2-.4.1-.2.2-.3.4-.2.2 0 .3.2.2.4zm2.6-7.7c-.1.2-.2.3-.4.2-.2-.1-.3-.2-.2-.4.1-.2.3-.3.4-.2.2 0 .3.2.2.4zm32.8 9.4c-.1.1-.3 0-.4-.1-.1-.1 0-.3.1-.4.1-.1.3 0 .4.1.1.1.1.3-.1.4zm-3.8-6.2c-.1.1-.3 0-.4-.1-.1-.1-.1-.3.1-.4.1-.1.3-.1.4.1 0 .2 0 .4-.1.4zm-3.8-6.3c0 .1-.1.1-.1.2-.1.1-.3 0-.4-.1-.1-.1-.1-.3.1-.4.1-.1.2-.1.3 0 .1 0 .1.1.1.1.1.1.1.2 0 .2zm-3.9-5.9c-.1.1-.3 0-.4-.1-.1-.1 0-.3.1-.4.1-.1.3 0 .4.1 0 .1 0 .3-.1.4zm-18.5 23.2c0 .2-.2.3-.4.2-.2 0-.3-.2-.2-.3 0-.2.2-.3.4-.2.1 0 .2.1.2.3zm1.6-7c0 .2-.2.3-.4.2-.2 0-.3-.2-.2-.3 0-.2.2-.3.4-.2.1 0 .2.1.2.3zm1.6-7.1c0 .2-.2.3-.4.2-.2 0-.3-.2-.2-.3 0-.2.2-.3.4-.2.2 0 .3.2.2.3zm29.9-8c-.1.1-.3.2-.4.1-.1-.1-.2-.3-.1-.4.1-.1.3-.2.4-.1.1.1.2.2.1.4zm-6-4.2c-.1.1-.3.2-.4.1-.1-.1-.2-.3-.1-.4.1-.1.3-.2.4-.1.2 0 .2.2.1.4zm-11.5 23c0 .2-.1.3-.3.3-.2 0-.3-.1-.3-.2 0-.2.1-.3.2-.4.2 0 .3.1.4.3zm-1.3-7.1c0 .2-.1.3-.2.3-.2 0-.3-.1-.3-.2 0-.2.1-.3.2-.4.2 0 .3.1.3.3zm-1.2-7.2c0 .2-.1.3-.2.3-.2 0-.3-.1-.3-.2 0-.2.1-.3.2-.3.2 0 .3.1.3.2zm-24.8 8.5c-.1.1-.3.2-.4.1-.1-.1-.2-.3-.1-.4.1-.1.3-.2.4-.1.2.1.2.3.1.4zm4.2-5.9c-.1.1-.3.2-.4.1-.1-.1-.2-.3-.1-.4.1-.1.3-.2.4-.1.2.1.2.3.1.4.1 0 0 0 0 0zm37-7.7c-.1.1-.2.1-.3 0-.1-.1-.1-.2 0-.3.1-.1.2-.1.3 0 .1.1.1.2 0 .3zm-2.9-3.2c-.1.1-.2.1-.3 0-.1-.1-.1-.2 0-.3.1-.1.2-.1.3 0 .1.2.1.3 0 .3zm-13.9 9.3c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2c.1.1.2.1.2.2zm.1-4.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2c.2 0 .2.1.2.2zm8.2.7c-.1 0-.2 0-.2-.1s0-.2.1-.2.2 0 .2.1c.1.1 0 .2-.1.2zm-1.5-4c-.1 0-.2 0-.2-.1s0-.2.1-.2.2 0 .2.1 0 .2-.1.2zm13.1 5.6c-.1.1-.2 0-.3-.1-.1-.1 0-.2.1-.3.1-.1.2 0 .3.1 0 .1 0 .2-.1.3zm-2.6-4.1c-.1.1-.2 0-.3-.1-.1-.1 0-.2.1-.3.1-.1.2 0 .3.1 0 .1 0 .2-.1.3zm-2.7-4.1h-.3c-.1-.1 0-.2.1-.3.1-.1.2 0 .3.1.1 0 0 .1-.1.2zm-14.9 11.7c0 .1-.1.2-.2.2s-.2-.1-.1-.2c0-.1.1-.2.2-.2.1-.1.1.1.1.2zm1.1-4.8c0 .1-.1.2-.2.1-.1 0-.2-.1-.1-.2 0-.1.1-.2.2-.2 0 .1.1.2.1.3zm20.7-10.5c-.1.1-.2.1-.3 0-.1-.1-.1-.2-.1-.3.1-.1.2-.1.3 0 .1.1.1.2.1.3zm-11.8 13c0 .1 0 .1 0 0-.2.1-.3 0-.3-.1s0-.2.2-.2c.1 0 .2.1.2.2 0 0 0 .1-.1.1zm-.7-5c0 .1 0 .2-.2.2-.1 0-.2 0-.2-.2 0-.1.1-.2.2-.2 0 .1.1.1.2.2zm7.2 16.9c0 .2-.1.4-.3.4-.2 0-.4-.1-.4-.3 0-.2.1-.4.3-.4.1 0 .3.1.4.3zm-1.3-8.2c0 .2-.1.4-.3.4-.2 0-.4-.1-.4-.3 0-.2.1-.4.3-.4.2 0 .3.1.4.3zm-1.3-8.3c0 .2-.1.4-.3.4s-.4-.1-.4-.3c0-.2.1-.4.3-.4.1 0 .3.1.4.3zm-30.6 16.8c-.1.2-.3.2-.5.1s-.2-.3-.1-.5c.1-.1.3-.2.5-.1s.2.3.1.5zm5-6.8c-.1.2-.3.2-.5.1s-.2-.3-.1-.5.3-.2.5-.1c.1.1.2.4.1.5zm35.8-8.8c-.2.1-.4 0-.5-.1-.1-.2 0-.4.1-.5.2-.1.4 0 .5.1.1.2 0 .4-.1.5zm-4.4-7.1c-.2.1-.4.1-.5-.1-.1-.2 0-.4.1-.5.2-.1.4-.1.5.1.1.2 0 .4-.1.5zm-18.4 26.4c-.1.2-.2.3-.4.3-.2-.1-.3-.2-.2-.4 0-.2.2-.3.4-.3.1 0 .2.2.2.4zm1.9-8.1c0 .2-.2.3-.4.3s-.3-.2-.2-.4c0-.2.2-.3.4-.3.1 0 .3.2.2.4zm2-8.1c0 .2-.2.3-.4.3s-.3-.2-.3-.4.2-.3.4-.3.3.2.3.4c0-.1 0-.1 0 0zm1.1 18.9c0 .2-.2.3-.4.3s-.3-.2-.3-.4.2-.3.4-.3c.3 0 .4.2.3.4zm1.7-8.2c0 .2-.2.3-.4.3s-.3-.2-.3-.4.2-.3.4-.3.3.2.3.4zm1.6-8.1c0 .2-.2.3-.4.3s-.3-.2-.3-.4.2-.3.4-.3.3.2.3.4zm1.6-8.2c0 .2-.2.3-.4.3s-.3-.2-.3-.4.2-.3.4-.3.3.2.3.4zm10.9 11.7c0 .2-.1.4-.3.4-.2 0-.4-.1-.4-.3 0-.2.1-.4.3-.4.2 0 .4.1.4.3zm-1.6-8.2c0 .2-.1.4-.3.4-.2 0-.4-.1-.4-.3 0-.2.1-.4.3-.4.1 0 .3.1.4.3zm-1.7-8.1c0 .2-.1.4-.3.4-.2 0-.4-.1-.4-.3 0-.2.1-.4.3-.4.2 0 .4.1.4.3zm-26.6 18.8c-.1.2-.3.2-.5.1s-.2-.3-.1-.5.3-.2.5-.1.2.3.1.5zm4.7-6.9c-.1.2-.3.2-.5.1s-.2-.3-.1-.5.3-.2.5-.1c.1.1.2.3.1.5zm9.3 2.8c-.1.1-.2.2-.3.1-.1-.1-.2-.2-.1-.3 0-.1.2-.2.3-.1.1 0 .1.2.1.3zm2.4-5.7c-.1.1-.2.2-.3.1-.1-.1-.2-.2-.1-.3.1-.1.2-.2.3-.1.1 0 .2.1.1.3zm2.5-5.8c-.1.1-.2.2-.3.1-.1-.1-.2-.2-.1-.3.1-.1.2-.2.3-.1.1 0 .2.2.1.3zm8.4 10.9c0 .1-.1.3-.3.3-.1 0-.3-.1-.3-.3 0-.1.1-.3.3-.3.2 0 .3.1.3.3zm.1-6.3c0 .1-.1.3-.3.3-.1 0-.3-.1-.3-.3 0-.1.1-.3.2-.3.3 0 .4.2.4.3zm.1-6.3c0 .1-.1.3-.2.3s-.3-.1-.3-.2.1-.3.3-.3c.1 0 .2.1.2.2zm1.4-1.2c0 .1-.1.1-.2.1s-.1-.1-.1-.2.1-.1.2-.1.1.1.1.2zm-4 5.5c-.1.1-.2.1-.3.1-.1-.1-.1-.2-.1-.3.1-.1.2-.1.3-.1.1 0 .2.2.1.3zm3-4.8c-.1.1-.2.1-.3.1-.1-.1-.1-.2-.1-.3.1-.1.2-.1.3-.1.2 0 .2.2.1.3zm3.1-4.8c-.1.1-.2.1-.3.1-.1-.1-.1-.2-.1-.3.1-.1.2-.1.3-.1.1 0 .1.2.1.3z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "L_hand-i4_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "2466.849",
                  y1: "-1615.857",
                  x2: "2737.75",
                  y2: "-467.237",
                  gradientTransform:
                    "matrix(-.06654 0 0 -.06632 466.377 61.265)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#ffbeb6" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#f2a19c" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#L_hand-i4_1_)" },
              attrs: {
                id: "L_hand-i4",
                d: "M275.4 111.9c.7-6.2 5.9-11.5 5.9-11.5s0 6.7-.3 7.2c-.3.6 7 3.3 7 3.3s2.3 13 5 14.8c2.8 1.8 4.7-3.4 9.5-5.1 4.8-1.7 6.2-.2 3.2 1.8s-13.6 11.1-12.4 20.3c1.4 10.9 14 31 17.5 36.6.7.6 1.2 1 1.1 1.3-.3 1.2 6.8 14.4 7.6 17.6.8 3.2-12.1 25.1-12.1 25.1-5.1-3.8-9.1-11.4-12.3-19.9-10.5-28.5-10.5-59.2-14.5-68-3.9-8.8-5.8-17.4-5.2-23.5z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "L_sleeve-i4_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "1255.138",
                  y1: "-1844.119",
                  x2: "2322.716",
                  y2: "-1844.119",
                  gradientTransform:
                    "matrix(-.06654 0 0 -.06632 466.377 61.265)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#23286b" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#151a4f" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#L_sleeve-i4_1_)" },
              attrs: {
                id: "L_sleeve-i4",
                d: "M326.8 170c2.9-7.3 2.8-8.1 3.2-11.8 1.1-10.6-17.7-16.1-17.7-16.1l15.7-15.6c37.4 10.1 48.2 31.8 52.3 44.1 5.1 15.2 2.6 25.4-5.9 34.2-6.5 6.7-14.5 7.2-27 21-11.1 12.3-34.4 14.9-34.4 14.9l-1.1-60.2c-.1-.1 7.2.8 14.9-10.5z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "hand-i4_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "1402.58",
                  y1: "3920.353",
                  x2: "767.013",
                  y2: "3241.696",
                  gradientTransform:
                    "matrix(-.05433 -.0383 -.03843 .05415 473.094 64.718)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#ffbeb6" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#f7aba5" },
                  attrs: { offset: ".646" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#f2a19c" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#hand-i4_1_)" },
              attrs: {
                id: "hand-i4",
                d: "M248.4 220s10.4 9.5 20.7 5c10.3-4.4 11.6-2.3 18.7 1.1 3.1 1.4 14.8 6.4 24 10l-6.1-23.1c-10.7.7-25.4 1.1-30.1-1-7.8-3.5-12.5-10.3-15.9-12.1-3.4-1.8-4.5-1.9-6.2.3 0 0-1.8-.6-6.4-2.6-9-3.3-3.4 18.7 1.3 22.4z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "sweater-i4_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "1378.877",
                  y1: "-1450.554",
                  x2: "1603.952",
                  y2: "-2832.509",
                  gradientTransform:
                    "matrix(-.06654 0 0 -.06632 466.377 61.265)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#23286b" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#151a4f" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#sweater-i4_1_)" },
              attrs: {
                id: "sweater-i4",
                d: "m312.2 142.1 15.7-15.6c10.5 1.3 20.6 4.5 29.9 9.3 5.1 2.7 10.1 5.7 14.8 9.2 21.5 15.7 21.6 24.9 33.6 34.3 0 0 .1 0 .1.1 12.1 9.5 27.9 20.7 22.6 42.5-5.4 3.1-10.5 5.9-15.4 8.4-16 8.1-29.5 12.7-40.7 15.1-6.7 1.5-13.6 2.3-20.5 2.3-5.5 0-10.9-.7-16.1-2.3-2-.6-4-1.4-5.9-2.4-5.4-.8-10.7-2-15.9-3.6 27.6-40.6-2.2-97.3-2.2-97.3z",
              },
            }),
            _c("path", {
              staticClass: "st13",
              attrs: {
                id: "R_sleeve-i4",
                d: "M312.2 142.1s33.5 21 25.9 50.1c-2.2 8.5-7.8 12.8-17.9 16-12.2 3.8-15.3 3.7-15.3 3.7l3.4 54.6s25.5.5 36.6-11.8c12.5-13.8 22.6-15.5 30.3-20.9 11.6-8.2 14.6-21.9 13.8-37.9-1.4-30.1-23.5-59.4-61-69.5",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "neck-i4_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "2060.349",
                  y1: "-1290.394",
                  x2: "2279.538",
                  y2: "-990.452",
                  gradientTransform:
                    "matrix(-.06654 0 0 -.06632 466.377 61.265)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#ffbeb6" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#f2a19c" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#neck-i4_1_)" },
              attrs: {
                id: "neck-i4",
                d: "M298.2 119.8s6.7 7.6 14 22.3c0 0 12.9 3 15.7-15.6 0 0-13.6-6.1-14-12.7l-15.7 6z",
              },
            }),
            _c("path", {
              staticClass: "st16",
              attrs: {
                id: "face-i4",
                d: "M280 100.9v1.9c.3 5.6-2.9 10.5-2.6 12 .3 1.5 3.4 2 4.8 1.9 1.4-.1 4.4 6.5 10.9 9.5 6.1 2.8 14 .9 18.8-3 0-12-1.9-20.2-14.1-23.4-13.4-3.5-15.2-8.7-15.2-8.7-1.7 3-2.5 6.4-2.6 9.8z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "hair-i4_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "2125.952",
                  y1: "174.077",
                  x2: "2347.856",
                  y2: "-296.228",
                  gradientTransform:
                    "matrix(-.06654 0 0 -.06632 466.377 61.265)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#e94a47" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#e94766" },
                  attrs: { offset: ".992" },
                }),
              ],
              1
            ),
            _c("ellipse", {
              staticStyle: { fill: "url(#hair-i4_1_)" },
              attrs: {
                id: "hair-i4",
                cx: "318.3",
                cy: "63.8",
                rx: "11.9",
                ry: "11.8",
              },
            }),
            _c("path", {
              staticClass: "st13",
              attrs: {
                id: "eyeglasses-i4",
                d: "M271.8 106.9c-1.1-3.1-.4-6.5 1.7-7.5 2-1.1 4.6.5 5.8 3.6.1.4.2.7.3 1.1 1.4-.4 2.7.3 3.9 1.1 0-.2 0-.4.1-.6.2-1.5 1.1-2.8 2.3-3.6 2.4-1.3 5.4.6 6.7 4.2.6 1.7.8 3.5.4 5.2-.2 1.2-.8 2.2-1.6 3.1-.2.2-.5.4-.7.5-1.2.6-2.7.5-3.8-.3-1.4-1-2.4-2.3-2.9-3.9-.4-1.2-.6-2.4-.6-3.7-1.1-.8-2.4-1.6-3.7-1.2.3 2.1-.3 4.1-1.5 5.2-.2.2-.4.3-.6.4-2.1 1.1-4.7-.5-5.8-3.6zm15.4 6.1c.9.7 2.1.8 3.1.3 1.1-.7 1.8-1.7 1.9-3 .3-1.5.2-3.1-.4-4.6-1.1-3.1-3.7-4.8-5.7-3.7-.2.1-.4.2-.6.4-.7.7-1.2 1.6-1.4 2.6-.3 1.5-.2 3.1.4 4.6.6 1.3 1.5 2.5 2.7 3.4zm-10-3.3c1.7-.9 2.2-3.8 1.3-6.4-1-2.6-3.1-4-4.8-3.1-1.7.9-2.2 3.8-1.3 6.4 1 2.6 3.2 4 4.8 3.1z",
              },
            }),
            _c("path", {
              staticClass: "st29",
              attrs: {
                id: "hair-2-i4",
                d: "M304.2 72.9c7.3-1.5 12.9-.2 17.1 2.2 5-.3 9.1-4.1 9.8-9 .1-.5.8-.3.7.2-.7 4.9-4.6 8.7-9.5 9.4 2.8 1.9 5 4.4 6.5 7.3.3.5.6.9 1 1.4 2.9 4.3 5.6 7.5 10.3 9.9 6.2 3.2 14.4 6.1 14.4 14.3 0 .2-.2.4-.4.4s-.4-.2-.4-.4c0-10.1-12.2-11.4-18.6-16.4-1.6-1.4-3.1-3-4.3-4.7 1.8 3.6 4.7 8 9.6 9.7 9.2 3.2 10.8 14 10.8 14-16 15.1-44.7 15.9-44.7 15.9-6-13 1.2-19.3-9.9-24.4C284 96.9 282.4 91 282.4 91c-1.6 3.1-2.5 6.6-2.6 10.2-5.2-17.8 10.8-25.5 24.4-28.3z",
              },
            }),
          ],
          1
        ),
      ]),
      _c("g", [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_30_", d: "M1231 691h237v427h-237z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_31_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_30_" },
          }),
        ]),
        _c(
          "g",
          { staticStyle: { "clip-path": "url(#SVGID_31_)" } },
          [
            _c("path", {
              staticClass: "st16",
              attrs: {
                d: "M1364.8 943.7c-6.8 3.6-11.7 1.6-18.7 2.6-9.3 1.4-6.3 6.9-5.9 14.6.7 12.7-1.4 25.6.3 37.7 5.5-3.4 8.2-8.1 10.3-13.9 2.5-6.8 3.7-8.2 10-11.9 5.5-3.2 10.4-6.7 16.1-9.6 5.2-2.6 12.9-4.3 16.9-8.4-3-6-3.2-12.3-4.4-18.5-8.1 1.2-17.3 7.7-24.6 7.4z",
              },
            }),
            _c("path", {
              staticClass: "st6",
              attrs: {
                d: "M1349.9 945.7c-7.4-1.1-22.1-2.5-22.8.2.1 9.8-.5 25.2-.4 36.2.1 12 0 25 .6 36.3.4 7.1 21.5-10.4 22.1-37.2.1-5.4.4-8.5.3-14.9 0-6.7-.2-18.2.2-20.6z",
              },
            }),
            _c("path", {
              staticClass: "st17",
              attrs: {
                d: "M1371.8 835.5c-2.3 1.8-10 7.5-11 6.8-2.6-2.4-.7-3.8 1.4-5.4-1.5.3-5.4 1-4.9-1.6.2-1.2 4.7-3.9 5.5-4.8 2.6-2.9 2.7-3.9 5.7-1 1.4 1.3 3.5 4.5 3.3 6z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_32_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "50.154",
                  y1: "1093.095",
                  x2: "58.215",
                  y2: "1096.058",
                  gradientTransform:
                    "matrix(1.3572 0 0 -1.3509 1288.145 2291.014)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#ffbeb6" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#f8afa9" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_32_)" },
              attrs: {
                d: "M1304.3 800.4c5.5 2.7 10.5 5.8 16.6 7.8 7.3 2.4 14.9 4 22.3 6.1 7.4 2.2 17.2 3 23.8 6.8 3.3 1.8 3.3 5.2 4.9 8.7 1.4 3.2 3.4 6.3 5 9.4 1 1.9 3.8 5.3 3.7 7.4-.3 5.6-4.1-.5-5.3-2.4-1.7-2.6-3.5-5-4.9-7.8-1.3-2.5-2.6-6.9-5-8.4-1.7-1.1-6.5-2.5-8.5-2.7-3.1-.2-24 4.5-26.8 3-2.9-1.6-11.6-1.1-14.9-1-5.1.1-14.9-2.9-17-5.1-1.2-1.2-2.2-3.1-3.4-4.4-2.7-3-4.2-6.3-5.2-10.2-.9-3.5-2.3-7.3-.3-10 1.7-2.4 6.3-4.6 9.1-5 1.1 2.1 4 6.9 5.9 7.8z",
              },
            }),
            _c("path", {
              staticClass: "st8",
              attrs: { d: "M1425.6 879.7h-49.4l31-62.6h49.4z" },
            }),
            _c("path", {
              staticClass: "st6",
              attrs: { d: "m1423.4 874.8-38.7-3.9 23.9-48.8h41z" },
            }),
            _c("path", {
              staticClass: "st16",
              attrs: {
                d: "M1391.6 1077.5c3.6 6.7 1.5 11.7 2.6 18.6 1.4 9.2 7 6.3 14.7 6 12.8-.6 25.7 1.5 37.9-.1-3.3-5.5-8.1-8.2-14-10.3-6.8-2.5-8.3-3.7-12-10-3.2-5.5-6.7-10.4-9.6-16.1-2.6-5.2-4.3-12.9-8.4-16.9-6 3-12.3 3.2-18.6 4.3 1.2 8 7.7 17.2 7.4 24.5z",
              },
            }),
            _c("path", {
              staticClass: "st27",
              attrs: {
                d: "M1318.2 846.8c-1.9 5.3-1.1 7.4-.3 12.9 1.1 8.4 3.1 8.6 11.8 9.9 18.2 2.8 38.9 7.4 57 10.8 14.2 2.7 36.8 7.6 43.1 23 5.6 14-9.5 31-19.2 39.7-13 11.6-27.9 20.6-40.5 32.8-8 7.8-19.8 20.8-23.8 31.1 1.3-7.7-2.3-19.4-3.5-27.4-1.5-9.8-2.5-17.9 2.3-27.3 1.9-3.8 8.1-9.5 11.3-12.2 5-4.2-.8-10.9 3.9-12.8 15.3-6.1 10.3-4.6 17.7-9.5-3.3 8-29.5 1.4-36.6-.1-12.5-2.5-25.1-2.8-37.4-5.4-6.6-1.4-14.2-2.1-18.6-8.2-4-5.5-9.9-13.8-11.4-20.1-3.8-16.2-2-31.3-1.4-47.6 12.6 7.8 31.6 5.5 46.1 9.4-1.2-1.2 1.1 1.7-.5 1z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_33_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "26.182",
                  y1: "1013.549",
                  x2: "64.215",
                  y2: "926.458",
                  gradientTransform:
                    "matrix(1.3572 0 0 -1.3509 1288.145 2291.014)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#23286b" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#151a4f" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_33_)" },
              attrs: {
                d: "M1262.8 828.2c-4 10.6-1.6 29.3.7 41 3 15.4 10.5 24.7 20.3 36.5 16.9 20.4 48.4 44.3 51.5 72.3 1.5 13.6 2.5 25.3 10.1 37.7 7.2 11.7 18.8 15.8 19.8 30.5s4.1 32.9 17 40.2c0 0 28.4 1.1 41.4-.4-6.6-12.2-13.3-28.2-18.5-38.5-6.4-12.7-11.9-25.7-16.4-38.9-9.2-27.2-11.4-61.1-27.1-85.8-6.1-9.6-14.5-17.9-22.5-25.9-4.1-4.1-8-8-11.2-12.6-3.6-5.1-4.6-7.6-6.9-13.6-4.9-12.9-8.2-29.1-4.4-42.2-17.9 0-36 .5-53.6-.8.6-1.5-.9 1.7-.2.5z",
              },
            }),
            _c("path", {
              staticClass: "st18",
              attrs: {
                d: "M1286 730.6c-12 8.9-13.9 18.1-18.1 32-7.8 25.3-14 56.1-30.2 77.5 17 19 50.2 19.9 73 16.4 8.3-1.3 22.1-4 22.1-4s-11.2-21.7-12.3-28.7c-2.4-14.7-2.4-27.2-.7-41.7 1.4-12.5 2.8-24.9 5-36.7 2-10.9-1.7-20.2-16.1-21.6-7.4-.9-15.8 1.7-22.7 6.8z",
              },
            }),
            _c("path", {
              staticClass: "st17",
              attrs: {
                d: "M1327.9 712c-5.1 5.7-12.4 10-18.4 12.8 2.3 6.1 9.8 11.7 16.5 13.8 4.3-6 9-4.6 13.7-10.2-5.2-4.2-8.4-9-10.6-15.5-.1 2.2-2-3.1-1.2-.9z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_34_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "76.578",
                  y1: "878.767",
                  x2: "132.523",
                  y2: "878.767",
                  gradientTransform:
                    "matrix(1.3572 0 0 -1.3509 1288.145 2291.014)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#008ec6" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#009bd3" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_34_)" },
              attrs: {
                d: "M1393.5 1092.3c-1.1 7.3-2.6 22 .1 22.7 9.9 0 25.3.6 36.3.6 12 0 25.1.1 36.5-.5 7.1-.4-10.3-21.4-37.3-22.2-5.5-.1-8.6-.4-15-.4-6.7.1-18.1.3-20.6-.2z",
              },
            }),
            _c("path", {
              staticClass: "st18",
              attrs: {
                d: "m1423.6 885.1-60.7 2.6v-8.8h63.3v3.6c0 1.4-1.2 2.5-2.6 2.6z",
              },
            }),
            _c("path", {
              staticClass: "st9",
              attrs: {
                d: "m1370 888.7-31.8-7.4c-1.2-.3-2.1-1.4-2.1-2.6v-4.6l33.9 5.8v8.8z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_35_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "45.482",
                  y1: "1161.835",
                  x2: "55.702",
                  y2: "1168.821",
                  gradientTransform:
                    "matrix(1.3572 0 0 -1.3509 1288.145 2291.014)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#ffbeb6" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#f8afa9" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_35_)" },
              attrs: {
                d: "M1339.2 704.2c6.7-9.1 16.6-11.2 28-5.4 9 4.5 9.4 20.5 2.4 31-3.7 5.5-12.7 19.6-30.3 14.8-14-3.8-6-26.7-4.2-34 0 .9 3.2-7.2 4.1-6.4z",
              },
            }),
            _c("path", {
              staticClass: "st29",
              attrs: {
                d: "M1364 708.5c5.5-.5 3.5 29.5 3.5 29.5l14.4-.4s3.2-28.9-12.1-34.6c-2.5 2.1-3.8 2.9-5.8 5.5z",
              },
            }),
            _c("path", {
              staticClass: "st29",
              attrs: {
                d: "M1385 737.4c-.4 0-.7-.4-.7-.7 1-10.2-5.5-27.6-13.7-32.1-.3-.2-.4-.6-.3-.9.2-.3.6-.4.9-.3 8.9 4.9 15.4 22.7 14.4 33.4.1.3-.2.6-.6.6z",
              },
            }),
            _c("path", {
              staticClass: "st16",
              attrs: {
                d: "M1348.7 824c1 .2 2.2 3.7 3.5 5.1 1.8 1.9 3.9 2.8 6.4 3.4 3.2.8 11 1.9 13.9 0 5.9-3.8-6.7-5.5-8.8-5.8-3.5-.5-11.5-5.5-14-2.9.2-.1-1.2.4-1 .2z",
              },
            }),
            _c("path", {
              staticStyle: { fill: "#c3d9fd" },
              attrs: { d: "m1379.3 873.3-43.4.8 29.8 5.3 60.5-.6z" },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_36_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "59.993",
                  y1: "1044.639",
                  x2: "36.995",
                  y2: "1077.12",
                  gradientTransform:
                    "matrix(1.3572 0 0 -1.3509 1288.145 2291.014)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#ffbeb6" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#f8afa9" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_36_)" },
              attrs: {
                d: "M1381.1 873.4c-3.8-1.1-6.6-4.5-10.9-6.2-8-3-13.1-15.3-17.7-22.2-5.1-7.8-10-13.5-16.3-20.1-5.1-5.3-10.9-14.1-17.4-17.6 0 .4.1.8.1 1.2-5.7.9-9-3.8-11 3.5-1.1 4 2 13.1 3.5 16.6 3.8 8.9 11 16.9 17.6 23.7 7 7.2 17.2 10.2 23.8 16.9 5.8 6 2.2 14.8 7.9 20.9 1.5.9 4.2-.8 6-.1 1.5.5 6.6-.3 10.5-2.2 3.9 1.4 1.8 3.2 6.3.3 1.6-1.2-2.8-6.2-7.9-11.3-.2-.4-.5-.7-.8-1.2 4 4.1 10.2 3.7 15.9 2.7 1.4-1.1-2.2-2.7-9.6-4.9z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_37_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "60.427",
                  y1: "1044.947",
                  x2: "37.43",
                  y2: "1077.428",
                  gradientTransform:
                    "matrix(1.3572 0 0 -1.3509 1288.145 2291.014)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#ffbeb6" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#f8afa9" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_37_)" },
              attrs: { d: "M1318.6 807.2c.1 0 .2.1.2.1-.1-.5-.1-.8-.2-.1z" },
            }),
            _c("path", {
              staticClass: "st18",
              attrs: {
                d: "M1315.6 739.5c8.6-.4 11.6 3.8 14 15.8 2 9.7 1.8 13.8 1.3 23.8-.9 17.9 5.7 35.6 17.6 50.1-6.5 8.2-33.9 10.4-43.8 10.8-1.7-32.8 8.5-38.8-1.4-62.1-8.5-20.4-3.1-37.6 12.3-38.4z",
              },
            }),
            _c("path", {
              staticClass: "st29",
              attrs: {
                d: "M1373.6 704.9c-6.6-19.6-37.3-15.6-46.1-5.2-10.5 12.4-9.1 40.9-8.3 56.3 4.1 1 32 .4 32 .4s-3.4-22.7 1.6-31.2c1.7-2.8 15.5 0 18.3-2.9 4.6-4.9 1.3-17.1 2.5-17.4z",
              },
            }),
            _c("g", [
              _c("path", {
                staticClass: "st13",
                attrs: {
                  d: "M1364.1 741.6h-.3c-3.5-1.4-3.9-2.3-4.9-5.1-.1-.4.1-.7.4-.9.4-.1.7.1.9.4.9 2.5 1.1 3 4.1 4.3.3.1.5.5.4.9-.1.2-.3.4-.6.4z",
                },
              }),
            ]),
            _c("path", {
              staticClass: "st4",
              attrs: {
                id: "texture-2_14_-i5",
                d: "M1276.9 890.2c0-.1-.1-.2-.2-.2s-.2.1-.2.2.1.2.2.2.2 0 .2-.2zm-8.8-19.5c.1-.1.1-.2 0-.3-.1-.1-.2-.1-.3 0-.1.1-.1.2 0 .3.1.1.2.1.3 0zm3.8 10.2c.1-.1.2-.2.1-.3-.1-.1-.2-.2-.3-.1-.1 0-.2.2-.1.3.1.1.2.1.3.1zm27.9-2.2c.2-.1.3-.3.2-.5-.1-.2-.3-.3-.5-.2-.2.1-.3.3-.2.5.1.1.3.2.5.2zm-9.1 3.3c.2-.1.3-.3.2-.5-.1-.2-.3-.3-.5-.2-.2.1-.3.3-.2.5.1.1.3.3.5.2zm-9.1 3.3c.2-.1.3-.3.2-.5-.1-.2-.3-.3-.5-.2-.2.1-.3.3-.2.5 0 .2.2.3.5.2zm17.1 14c0-.2-.2-.4-.4-.4s-.4.2-.4.4.2.4.4.4.4-.1.4-.4zm-9.7-.4c0-.2-.2-.4-.4-.4s-.4.2-.4.4.2.4.4.4.4-.1.4-.4zm-2.9-34.2c.2-.2.2-.4 0-.6-.1-.2-.4-.2-.6 0-.2.1-.2.4-.1.5.2.2.5.2.7.1zm-7.2 6.6c.2-.2.2-.4 0-.6-.2-.2-.4-.2-.6 0-.2.1-.2.4 0 .6.2.1.4.1.6 0zm-7.2 6.5c.2-.1.2-.4 0-.5-.1-.2-.4-.2-.6 0-.2.2-.2.4 0 .6.2.1.5.1.6-.1zm26.4 31c0-.2-.1-.4-.3-.4-.2 0-.4.1-.4.3 0 .2.1.4.3.4.2.1.4-.1.4-.3zm-9.4-35c.2-.1.2-.4.1-.5-.1-.2-.3-.2-.5-.1s-.2.3-.1.5.3.2.5.1zm-6.9 5.2c.2-.1.2-.3.1-.5s-.3-.2-.5-.1-.2.3-.1.5.3.3.5.1zm-7 5.3c.2-.1.2-.3.1-.5s-.3-.2-.5-.1-.2.3-.1.5.4.2.5.1zm17.9 8.1c.2-.1.3-.3.2-.4 0-.2-.2-.3-.4-.3-.2.1-.3.2-.3.4.1.2.3.3.5.3zm-8.4 2.2c.2 0 .3-.2.3-.4s-.2-.3-.4-.3c-.2.1-.3.2-.3.4s.2.3.4.3zm-11.3-29c.1-.2 0-.4-.1-.5-.2-.1-.4-.1-.5.1-.1.2 0 .4.1.5.2.2.4.1.5-.1 0 .1 0 .1 0 0zm-4.4 7.5c.1-.2 0-.4-.1-.5-.2-.1-.4 0-.5.1-.1.2 0 .4.1.5.2.2.4.1.5-.1zm38 32.1c.2-.1.3-.3.3-.5-.1-.2-.3-.4-.5-.3-.2.1-.3.3-.3.5 0 .3.3.4.5.3zm-9.7 2.6c.2-.1.4-.3.3-.5-.1-.2-.3-.4-.5-.3-.2.1-.4.3-.3.5 0 .3.3.4.5.3zm-15.9-36c.1-.2 0-.5-.2-.6-.2-.1-.5 0-.6.2-.1.2 0 .4.2.6.2 0 .5 0 .6-.2zm-5 8.6c.1-.2 0-.4-.2-.6-.2-.1-.5 0-.6.2-.1.2 0 .5.2.6.2.1.5 0 .6-.2zm17.8 9c.2-.1.2-.4.1-.6-.1-.2-.4-.2-.6-.1-.2.1-.2.4-.1.6.2.2.4.2.6.1zm-7.9 6.1c.2-.1.2-.4.1-.6-.1-.2-.4-.2-.6-.1-.2.1-.2.4-.1.6.1.2.4.2.6.1zm13.4-1.9c.2-.1.2-.4.1-.6s-.4-.2-.6-.1c-.2.1-.2.4-.1.6.1.2.4.2.6.1zm-8.2 5.8c.2-.1.2-.4.1-.6-.1-.2-.4-.2-.6-.1-.2.1-.2.4-.1.6.2.2.4.2.6.1zm-10-16.1c.1-.2.1-.5-.1-.6-.2-.1-.4-.1-.6.1-.1.2-.1.4.1.6.2.2.4.1.6-.1z",
              },
            }),
          ],
          1
        ),
      ]),
      _c("g", [
        _c("defs", [
          _c("path", { attrs: { id: "SVGID_38_", d: "M455 222h76v43h-76z" } }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_39_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_38_" },
          }),
        ]),
        _c(
          "g",
          { staticStyle: { "clip-path": "url(#SVGID_39_)" } },
          [
            _c("path", {
              staticClass: "st59",
              attrs: {
                d: "M481.8 222v26.8H455V222h26.8zm-13.4 21.8c4.6 0 8.4-3.8 8.4-8.4 0-4.6-3.8-8.4-8.4-8.4-4.6 0-8.4 3.8-8.4 8.4 0 4.7 3.8 8.4 8.4 8.4z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_40_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "-5609.12",
                  y1: "839.415",
                  x2: "-4840.749",
                  y2: "839.415",
                  gradientTransform:
                    "matrix(-.06539 0 0 -.06528 164.246 298.3)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#d6d7d8" },
                  attrs: { offset: ".005" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#eee" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_40_)" },
              attrs: { d: "M498.3 222H531l-12.5 43h-40.4l-12.5-43z" },
            }),
            _c("path", {
              staticClass: "st61",
              attrs: { d: "m469.6 235.5 8.5 29.5h40.4l8.6-29.5z" },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_41_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "3259.082",
                  y1: "699.526",
                  x2: "4071.527",
                  y2: "699.526",
                  gradientTransform: "matrix(.06539 0 0 -.06528 258.663 298.3)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#23286b" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#151a4f" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_41_)" },
              attrs: { d: "m524.9 240.9-6.8 23.5h-39.4l-6.8-23.5h53" },
            }),
            _c("path", {
              staticClass: "st59",
              attrs: {
                d: "m529.5 222-.4 1.4-11.7 40.2h-38.2l-11.7-40.2-.4-1.4h-1.5l12.5 43h40.4l12.5-43z",
              },
            }),
            _c("path", {
              staticClass: "st4",
              attrs: {
                id: "texture_5_-i6",
                d: "M514.3 260.8v.2h-.2v-.2c.1 0 .2-.1.2 0zm-1.9-1.3c-.1 0 0 .1 0 .2s.1 0 .2 0 0-.1 0-.2h-.2zm4.9-.1c0 .2.1.1.1.1.1-.1 0-.1-.1-.1.2-.1.1-.1 0 0zm-1.1-2c-.1.1 0 .1 0 0 0 .2.1.1.1.1l-.1-.1zm-1.2-1.8c-.1 0-.1.1 0 0 0 .2.1.1.1.1s0-.1-.1-.1c.1 0 0-.1 0 0zm-5.4 7.7c0 .1 0 .1.1.1s.1 0 .1-.1 0-.1-.1-.1l-.1.1zm5.7-2.3v.2h.2v-.2c-.1-.1-.1 0-.2 0zm-2.8-1.3v.2h.2v-.2c-.1-.2-.1-.1-.2 0zm-2.7-1.5v.2h.2v-.2c-.1-.1-.2-.1-.2 0zm-2.7-1.4v.2h.2v-.2c-.2-.1-.3-.1-.2 0zm10.9-1.9c-.1 0-.1.1-.1.1 0 .1.1.1.1.1l.1-.1c0-.1-.1-.1-.1-.1zm-1-3c-.1 0-.1.1-.1.1 0 .1.1.1.1.1.1 0 .1-.1.1-.1 0-.1 0-.2-.1-.1zm-.9-3c-.1 0-.1.1-.1.1 0 .1.1.1.1.1.1 0 .1-.1.1-.1 0-.1-.1-.1-.1-.1zm-.3 9c-.1 0-.1.1 0 .2 0 .1.1.1.2 0 .1 0 .1-.1 0-.2h-.2zm-2-2.4c-.1 0-.1.1 0 .2 0 .1.1.1.2 0 .1 0 .1-.1 0-.2h-.2zm-2-2.3c-.1 0-.1.1 0 .2 0 .1.1.1.2 0 .1 0 .1-.1 0-.2-.1 0-.2-.1-.2 0zm-2-2.4c-.1 0-.1.1 0 .2 0 .1.1.1.2 0 .1 0 .1-.1 0-.2h-.2zm7.6 7.7c-.1 0 0 .1 0 .2s.1 0 .2 0 0-.1 0-.2h-.2zm-1.7-1.7c-.1 0 0 .1 0 .2s.1 0 .2 0 0-.1 0-.2c-.1.1-.2 0-.2 0zm-1.7-1.6c-.1 0 0 .1 0 .2s.1 0 .2 0 0-.1 0-.2h-.2zm-1.6-1.7c-.1 0 0 .1 0 .2s.1 0 .2 0 0-.1 0-.2c-.1 0-.2-.1-.2 0zm1.3 8.4c0 .1.1.1.1.1.1 0 .1-.1.1-.1 0-.1-.1-.1-.1-.1l-.1.1zm-2.4.1c0 .1.1.1.1.1.1 0 .1-.1.1-.1 0-.1-.1-.1-.1-.1s-.1 0-.1.1zm-2.3-.1c0 .1.1.1.1.1.1 0 .1-.1.1-.1 0-.1-.1-.1-.1-.1-.1 0-.1.1-.1.1zm8.6-7.8c-.1 0-.1 0-.1.1s0 .1.1.1.1 0 .1-.1l-.1-.1zm-.9-2.2c-.1 0-.1 0-.1.1s0 .1.1.1.1 0 .1-.1l-.1-.1zm-.9-2.1c-.1 0-.1 0-.1.1s0 .1.1.1.1 0 .1-.1-.1-.2-.1-.1zm-.6 9.8c-.1 0 0 .1.1.1 0 .1.1 0 .1-.1.1 0 0-.1-.1-.1 0 0-.1 0-.1.1zm-2.2-.9c-.1 0 0 .1.1.1 0 .1.1 0 .1-.1.1 0 0-.1-.1-.1l-.1.1zm-2.2-.9c-.1 0 0 .1.1.1 0 .1.1 0 .1-.1.1 0 0-.1-.1-.1l-.1.1zm-2.1-.9c-.1 0 0 .1.1.1 0 .1.1 0 .1-.1.1 0 0-.1-.1-.1s-.1 0-.1.1zm9.2.5s-.1.1 0 0c0 .1 0 .1 0 0 .1 0 .1 0 0 0zm-1-.9c-.1.1-.1.1 0 0 0 .1 0 .2 0 0 0 .2.1.1 0 0zm-1.1-.7c.1 0 .1.1 0 0 .1 0 .1 0 0 0 .1 0 0 0 0 0zm1.2 4.5c.1 0 0 0 0 0zm-1.3.2zm-1.3.1zm3.7-6s0 .1 0 0c0 .1.1.1.1.1 0-.1 0-.1-.1-.1.1 0 .1-.1 0 0zm-.6-1.1s-.1 0 0 0c0 .1.1.1.1.1-.1-.1 0-.1-.1-.1.1-.1.1-.1 0 0zm-.9 5c-.1-.1-.1-.1 0 0zm-1.3-.4zm-1.3-.3c.1-.1.1-.1 0 0zm4-3.8c-.1 0 0 .1 0 .2s.1 0 .2 0 0-.1 0-.2c-.1.1-.1 0-.2 0zm-1.6-1.8c-.1 0 0 .1 0 .2s.1 0 .2 0 0-.1 0-.2c0 0-.1-.1-.2 0zm-1.5-1.9c-.1 0 0 .1 0 .2s.1 0 .2 0 0-.1 0-.2h-.2zm-1.7-1.8c-.1 0 0 .1 0 .2s.1 0 .2 0 0-.1 0-.2-.1-.1-.2 0zm3.2 9c0 .1.1.1.1.1.1 0 .1-.1.1-.1 0-.1-.1-.1-.1-.1-.1 0-.2 0-.1.1zm-2.5-.2c0 .1.1.1.1.1.1 0 .1-.1.1-.1 0-.1-.1-.1-.1-.1l-.1.1zm-2.4-.2c0 .1.1.1.1.1l.1-.1c0-.1-.1-.1-.1-.1-.1 0-.1.1-.1.1zm-2.4-.2c0 .1.1.1.1.1.1 0 .1-.1.1-.1 0-.1-.1-.1-.1-.1-.1 0-.2 0-.1.1zm9.5-7.4c-.1 0-.1.1-.1.1 0 .1.1.1.1.1.1 0 .1-.1.1-.1 0-.1 0-.1-.1-.1zm-.8-2.4c-.1 0-.1.1-.1.1 0 .1.1.1.1.1.1 0 .1-.1.1-.1.1-.1 0 0-.1-.1zm-.7-2.3c-.1 0-.1.1-.1.1 0 .1.1.1.1.1.1 0 .1-.1.1-.1 0-.1 0-.1-.1-.1zm.8 11.2c-.1 0 0 .1.1.1 0 .1.1 0 .1-.1.1 0 0-.1-.1-.1 0 0 0 .1-.1.1zm-2.2-1.1c-.1 0 0 .1.1.1 0 .1.1 0 .1-.1.1 0 0-.1-.1-.1l-.1.1zm-2.2-1.1c-.1 0 0 .1.1.1 0 .1.1 0 .1-.1.1 0 0-.1-.1-.1l-.1.1zm-2.1-1.1c-.1 0 0 .1.1.1 0 .1.1 0 .1-.1.1 0 0-.1-.1-.1 0 0-.1 0-.1.1zm-2.2-1.2c-.1 0 0 .1.1.1 0 .1.1 0 .1-.1.1 0 0-.1-.1-.1 0 .1-.1.1-.1.1zm6.2 8.1c0 .1.1.1.1.1.1 0 .1-.1.1-.1 0-.1-.1-.1-.1-.1-.1 0-.1.1-.1.1zm-2.4.7c0 .1.1.1.1.1.1 0 .1-.1.1-.1 0-.1-.1-.1-.1-.1l-.1.1zm-2.3.8c0 .1.1.1.1.1.1 0 .1-.1.1-.1 0-.1-.1-.1-.1-.1-.1 0-.1 0-.1.1zm-2.3.8c0 .1.1.1.1.1.1 0 .1-.1.1-.1 0-.1-.1-.1-.1-.1-.1 0-.1 0-.1.1zm11.1-13.9s-.1 0 0 0c0 .1 0 .2.1.1l-.1-.1zm-2.1 5.3s0 .1 0 0c.1 0 .1.1 0 0 .1 0 .1-.1 0 0zm-1.4-.8s0 .1 0 0c.1 0 .1.1 0 0 .1 0 .1-.1 0 0zm-1.4-.8s0 .1 0 0c.1.1.2.1 0 0 .1 0 .2-.1 0 0zm2.4 5.3c.2 0 .2 0 .1-.1 0 0-.1-.1-.1.1 0-.1-.1-.1 0 0zm-1.6.4c.1 0 .2 0 .1-.1 0 0 0-.1-.1.1 0-.1 0 0 0 0zm-1.5.4s0 .1 0 0c.1 0 .2 0 .1-.1 0 0-.1 0-.1.1 0-.1 0-.1 0 0zm4.3-6.6c-.1 0-.1.1 0 0 0 .2.1.1.1.1s0-.1-.1-.1c0-.1 0 0 0 0zm-1.1-1.3c0 .1 0 .1 0 0 0 .2.1.1.1.1.1 0 0-.1-.1-.1.1 0 .1 0 0 0zm-.9-1.2s0 .1 0 0c0 .2.1.1.1.1.1 0 0-.1-.1-.1.1-.1 0 0 0 0zm1.3 6.4zm-1.5-.2zm-1.6-.2c0-.1 0-.1 0 0zm-1.6-.2c.1-.1.1-.1 0 0zm4.3 4.5c0 .1.1.1 0 0 .2 0 .1-.1.1-.1-.1 0-.1 0-.1.1-.1 0 0 0 0 0zm-1.3 1s.1 0 0 0c.2 0 .1-.1.1-.1s-.1 0-.1.1zm-1.2 1s.1 0 0 0c.2 0 .1-.1.1-.1-.1-.1-.1 0-.1.1-.1-.1-.1-.1 0 0zm5.6-14.6c-.1 0-.1.1-.1.1 0 .1.1.1.1.1.1 0 .1-.1.1-.1 0-.1 0-.1-.1-.1zm-.5-2.4c-.1 0-.1.1-.1.1 0 .1.1.1.1.1.1 0 .1-.1.1-.1 0-.1 0-.1-.1-.1zm-.4-2.4c-.1 0-.1.1-.1.1 0 .1.1.1.1.1.1 0 .1-.1.1-.1 0-.1-.1-.1-.1-.1zm-1.8 9.4c-.1 0 0 .1 0 .2s.1 0 .2 0 0-.1 0-.2-.1-.1-.2 0zm-1.9-1.4c-.1 0 0 .1 0 .2s.1 0 .2 0 0-.1 0-.2c-.2-.1-.3-.1-.2 0zm-2.1-1.4c-.1 0 0 .1 0 .2s.1 0 .2 0 0-.1 0-.2c-.1-.1-.1 0-.2 0zm-2-1.4c-.1 0 0 .1 0 .2s.1 0 .2 0 0-.1 0-.2h-.2zm5.4 7.9c0 .1.1.1.1.1.1 0 .1-.1.1-.1 0-.1-.1-.1-.1-.1-.1 0-.1.1-.1.1zm-2.4.4c0 .1.1.1.1.1.1 0 .1-.1.1-.1 0-.1-.1-.1-.1-.1-.1.1-.2.1-.1.1zm-2.4.5c0 .1.1.1.1.1.1 0 .1-.1.1-.1l-.1-.1c-.1 0-.1 0-.1.1zm-2.4.5c0 .1.1.1.1.1.1 0 .1-.1.1-.1 0-.1-.1-.1-.1-.1-.1 0-.1 0-.1.1zm8.6-7.7c-.1 0 0 .1 0 .2s.1 0 .2 0 0-.1 0-.1c0-.1-.1-.2-.2-.1zm-1.3-2.1c-.1 0 0 .1 0 .2s.1 0 .2 0 0-.1 0-.1c0-.1-.1-.1-.2-.1zm-1.3-2c-.1 0 0 .1 0 .2s.1 0 .2 0 0-.1 0-.2c-.1 0-.2-.1-.2 0zm-1.3-2c-.1 0 0 .1 0 0 0 .2.1.1.1.1s0-.1-.1-.1zm3.7 10.5c0 .1 0 .2.1.1.1 0 .2 0 .1-.1 0-.1 0-.2-.1-.1 0 0-.1 0-.1.1zm-2.4-.4c0 .1 0 .2.1.1.1 0 .1 0 .1-.1s0-.1-.1-.1c0-.1-.1 0-.1.1zm-2.4-.6c0 .1 0 .2.1.1.1 0 .1 0 .1-.1s0-.2-.1-.1l-.1.1zm-2.4-.5c0 .1 0 .2.1.1.1 0 .2 0 .1-.1 0-.1 0-.2-.1-.1l-.1.1zm-2.3-.5c0 .1 0 .2.1.1.1 0 .1 0 .1-.1s0-.2-.1-.1l-.1.1zm8 6.1c0 .1.1.1 0 0 .2 0 .1-.1.1-.1s-.1 0-.1.1zm-2 1.4c0 .1.1 0 .2 0s0-.1 0-.1c0-.1-.1 0-.1 0-.2 0-.1.1-.1.1zm-2.1 1.4c0 .1.1 0 .2 0s0-.1 0-.2-.1 0-.2 0v.2zm-2 1.3s.1 0 0 0c.2 0 .1-.1.1-.1 0-.1-.1 0-.2 0 .1 0 .1 0 .1.1zm9.3-13.1s-.1 0 0 0c0 .1.1.1.1.1s0-.1-.1-.1zm-.8-1.2c-.1 0-.1 0 0 0 0 .1.1.1.1.1-.1-.1 0-.1-.1-.1.1-.1 0 0 0 0zm-.8-1.3s-.1.1 0 0c0 .1.1.1.1.1l-.1-.1zm-.3 5.4c0-.1 0-.1 0 0zm-1.5-.4c.1 0 .1 0 0 0zm-1.4-.2c0-.1 0-.1 0 0zm3.6 3.9s0 .1 0 0c.1 0 .1-.1.1-.1-.1 0-.1 0-.1.1-.1 0-.1 0 0 0zm-1.3.8c0 .1 0 0 0 0 .1 0 .1-.1.1-.1l-.1.1zm-1.3.8c.1.1.1.1 0 0 .1 0 .1-.1.1-.1l-.1.1c.1-.1 0 0 0 0zm4.8-12.2c0 .1 0 .2.1.1 0 0 .1 0-.1-.1.1.1 0 0 0 0zm-1.6 5.9s0 .1 0 0c0 .1.1.1 0 0 .1 0 .1-.1 0 0 .1 0 0 0 0 0zm-1.2-.8s0 .1 0 0c0 .1.1.1 0 0 .1 0 .1-.1 0 0zm-1.3-.8s0 .1 0 0c.1 0 .2.1 0 0 .1 0 .2-.1 0 0 .1 0 .1 0 0 0zm-1.2-.9s0 .1 0 0c.1 0 .2.1 0 0 .1 0 .2-.1 0 0zm3.1 5.3s0 .1 0 0c.1 0 .2 0 .1-.1 0 .1-.1 0-.1.1zm-1.4.3s0 .1 0 0c.1 0 .2 0 .1-.1l-.1.1c-.1 0-.1 0 0 0zm-1.5.3c.1 0 .2 0 .1-.1 0 0 0-.1-.1.1zm-1.4.3c.1 0 .2 0 .1-.1 0 0-.1-.1-.1.1 0-.1-.1-.1 0 0zm4.6-4.9c0 .1.1 0 0 0 .1 0 0 0 0 0s-.1-.1 0 0zm-1.2-.4c.1 0 .1 0 0 0 .1 0 .1 0 0 0 .2 0 .2 0 0 0 .1-.1.1-.1 0 0zm1.4 4.1c.1 0 .1 0 0 0 0-.1 0-.1 0 0zm-1.1.5c.1 0 .1 0 0 0 0-.1 0-.1 0 0zm1.4-6.3c-.1 0 0 .1 0 0 0 .1 0 .1 0 0 .1 0 .1 0 0 0zm-.9-.8c0 .1 0 .1 0 0 .1 0 .1 0 0 0 .1 0 0 0 0 0zm.6 4.6c.1.1.1.1 0 0 .1.1.1.1 0 0 .2 0 .1 0 0 0 .1 0 0 0 0 0zm-1.2.1c.1.1.1.1 0 0 .1 0 .1 0 0 0 .2 0 .2-.1 0 0 .1 0 0 0 0 0zm-1.1.1c.1-.1.1-.1 0 0 0-.1 0 0 0 0zm3-3.3zm-1.4.2c0-.1-.1-.1 0 0zm.1 3c.1 0 .2 0 .1-.1-.1 0-.1 0-.1.1 0-.1 0-.1 0 0z",
              },
            }),
          ],
          1
        ),
      ]),
      _c("g", [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_42_", d: "M584 146h215v119H584z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_43_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_42_" },
          }),
        ]),
        _c(
          "g",
          { staticStyle: { "clip-path": "url(#SVGID_43_)" } },
          [
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_44_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "828.147",
                  y1: "363.233",
                  x2: "1465.132",
                  y2: "363.233",
                  gradientTransform: "matrix(.2867 0 0 -.2885 362.797 310.287)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#a1e7fc" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#009bd3" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_44_)" },
              attrs: { d: "M600.2 146h182.6v119H600.2z" },
            }),
            _c("path", {
              staticClass: "st4",
              attrs: { d: "M604.6 155.2h173.8v91.7H604.6z" },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_45_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "1129.912",
                  y1: "351.017",
                  x2: "1411.907",
                  y2: "351.017",
                  gradientTransform: "matrix(.2867 0 0 -.2885 362.797 310.287)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#deeafe" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#a1c3fc" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_45_)" },
              attrs: {
                d: "M767.5 228.9h-80.8v-29.3c0-5.8 4.7-10.5 10.4-10.5h70.4v39.8zm-79.7-1.1h78.6v-37.6h-69.3c-5.1 0-9.3 4.2-9.3 9.4v28.2z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_46_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "1042.692",
                  y1: "309.406",
                  x2: "1324.687",
                  y2: "309.406",
                  gradientTransform: "matrix(.2867 0 0 -.2885 362.797 310.287)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#deeafe" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#a1c3fc" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_46_)" },
              attrs: {
                d: "M742.5 240.9h-80.8v-29.3c0-5.8 4.7-10.5 10.4-10.5h70.4v39.8zm-79.7-1.1h78.6v-37.6h-69.3c-5.1 0-9.3 4.2-9.3 9.4v28.2z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_47_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "878.887",
                  y1: "477.224",
                  x2: "1418.382",
                  y2: "477.224",
                  gradientTransform: "matrix(.2867 0 0 -.2885 362.797 310.287)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#deeafe" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#a1c3fc" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_47_)" },
              attrs: {
                d: "M769.4 181.6H614.7v-9.8c0-4.5 3.6-8.2 8.1-8.2h146.5l.1 18z",
              },
            }),
            _c("path", {
              staticClass: "st8",
              attrs: { d: "M584 256.9h215v8.1H584z" },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_48_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "966.847",
                  y1: "481.086",
                  x2: "1000.24",
                  y2: "481.086",
                  gradientTransform: "matrix(.2867 0 0 -.2885 362.797 310.287)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#a1c3fc" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#009bd3" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_48_)" },
              attrs: { d: "M640 166.7h9.6v9.6H640z" },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_49_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "1173.065",
                  y1: "363.201",
                  x2: "1206.457",
                  y2: "363.201",
                  gradientTransform: "matrix(.2867 0 0 -.2885 362.797 310.287)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#a1c3fc" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#009bd3" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_49_)" },
              attrs: { d: "M699.1 200.7h9.6v9.6h-9.6z" },
            }),
            _c("path", {
              staticClass: "st4",
              attrs: { d: "M640.2 168h2.6v2.6h-2.6z" },
            }),
            _c("path", {
              staticClass: "st9",
              attrs: { d: "M768.8 238.7h2.6v2.6h-2.6z" },
            }),
            _c("path", {
              staticClass: "st61",
              attrs: { d: "M694 250.5h2.6v2.6H694z" },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_50_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "987.269",
                  y1: "437.792",
                  x2: "1013.002",
                  y2: "437.792",
                  gradientTransform: "matrix(.2867 0 0 -.2885 362.797 310.287)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#a1c3fc" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#009bd3" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_50_)" },
              attrs: { d: "M645.8 180.3h7.4v7.4h-7.4z" },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_51_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "1285.405",
                  y1: "470.152",
                  x2: "1311.137",
                  y2: "470.152",
                  gradientTransform: "matrix(.2867 0 0 -.2885 362.797 310.287)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#a1c3fc" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#009bd3" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_51_)" },
              attrs: { d: "M731.3 171h7.4v7.4h-7.4z" },
            }),
            _c("path", {
              staticClass: "st9",
              attrs: { d: "M717.7 187.9h7.4v7.4h-7.4z" },
            }),
            _c("path", {
              staticClass: "st29",
              attrs: { d: "M634.7 186.8h5.2v5.2h-5.2z" },
            }),
            _c("path", {
              staticClass: "st9",
              attrs: { d: "M680.8 196.7h5.2v5.2h-5.2z" },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_52_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "992.377",
                  y1: "383.557",
                  x2: "1007.897",
                  y2: "383.557",
                  gradientTransform: "matrix(.2867 0 0 -.2885 362.797 310.287)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#a1c3fc" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#009bd3" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_52_)" },
              attrs: { d: "M647.3 197.4h4.4v4.5h-4.4z" },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_53_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "992.377",
                  y1: "281.677",
                  x2: "1007.897",
                  y2: "281.677",
                  gradientTransform: "matrix(.2867 0 0 -.2885 362.797 310.287)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#a1c3fc" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#009bd3" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_53_)" },
              attrs: { d: "M647.3 226.8h4.4v4.5h-4.4z" },
            }),
            _c("path", {
              staticClass: "st18",
              attrs: {
                d: "M604.6 258.3h20.6v5.2h-20.6zM632.5 258.3h14.2v5.2h-14.2z",
              },
            }),
          ],
          1
        ),
      ]),
      _c("g", [
        _c("g", [
          _c("defs", [
            _c("path", {
              attrs: { id: "SVGID_54_", d: "M1083 153h43v113h-43z" },
            }),
          ]),
          _c("clipPath", { attrs: { id: "SVGID_55_" } }, [
            _c("use", {
              staticStyle: { overflow: "visible" },
              attrs: { "xlink:href": "#SVGID_54_" },
            }),
          ]),
          _c(
            "g",
            { staticStyle: { "clip-path": "url(#SVGID_55_)" } },
            [
              _c("path", {
                staticClass: "st4",
                attrs: {
                  d: "M1091.9 188.2c-2.5 0-4.6 1.1-5.9 2.6-1.3 1.5-1.9 3.3-2.3 5.1-2.9 13.5 3.4 28.3 1.6 42.1 4.1.5 8.2 1 12.4 1.5 5-12.2 6.6-25.5 5.1-39-.3-2.6-.7-5.3-2.4-7.8-1.8-2.3-5.1-4.4-8.5-4.5z",
                },
              }),
              _c("path", {
                staticClass: "st75",
                attrs: {
                  d: "M1103.1 214.6c-6.3.7-12.7 1.5-18.8 2.7-.1-.8-.2-1.7-.3-2.5 6.1-.7 12.5-.7 19.1-.2z",
                },
              }),
              _c("path", {
                staticClass: "st75",
                attrs: {
                  d: "M1103.3 208.7c0 1.8 0 3.5-.1 5.3-6.6-.6-13.1-.5-19.4.2 0-.2 0-.3-.1-.5 3-.9 6.1-1.6 9.2-2.3 3.5-.8 7.1-1.6 10.4-2.7zM1084.7 221c3.7.1 7.4.6 10.9 1.1l6.7.9c-.2 1-.4 2.1-.6 3.1-5.8-.2-11.5-.5-16.6-1.8-.1-1.1-.2-2.2-.4-3.3zM1084.3 218c6.2-1.2 12.5-2 18.8-2.8-.1 2.3-.4 4.6-.7 6.8-5.9-1.5-11.9-2.4-18-2.9 0-.3 0-.7-.1-1.1zM1092.8 198.2l-9.5 1.1c.1-1.2.3-2.3.5-3.4 5.1-1.8 10.9-2.8 16.3-3.5.1.1.2.2.3.4 1.1 1.5 1.6 3.1 2 4.7-3.4 0-6.7.4-9.6.7zM1099.9 222.1l-4.3-.6c-3.5-.5-7.2-.9-11-1.1 0-.2-.1-.4-.1-.6 5.2.4 10.3 1.1 15.4 2.3zM1083 204c6.3-2 12.8-3.6 19.6-4.7.1.4.1.8.1 1.2.2 1.6.3 3.2.4 4.7l-20.1.2V204zM1083.9 195.2c.4-1.6 1-3.1 2.1-4.4 1.3-1.5 3.4-2.6 5.9-2.6 3 0 5.8 1.6 7.7 3.6-5.2.8-10.7 1.7-15.7 3.4zM1101.6 226.7c-.9 4.4-2.2 8.7-3.9 12.9-4.1-.5-8.2-1-12.4-1.5.6-4.3.4-8.6-.1-13.1 5.1 1.1 10.7 1.5 16.4 1.7zM1102.4 198.1c0 .2.1.4.1.6-6.8 1.1-13.3 2.6-19.5 4.6 0-1.1.1-2.2.2-3.3l9.8-1.2c2.9-.3 6.2-.7 9.4-.7zM1083.4 210.9v-.3c4.5-1.6 10-2.5 16.9-3l-16.9 3.3z",
                },
              }),
              _c("path", {
                staticClass: "st75",
                attrs: {
                  d: "M1103.2 206.8c-.3 0-.6 0-.9.1-7.8.4-14 1.4-19 3-.1-1.3-.2-2.5-.3-3.8l20.2-.2v.9zM1103.3 208c-3.4 1.2-7.1 2-10.7 2.8-3 .7-6.1 1.4-9 2.2-.1-.5-.1-1-.2-1.6l19.8-3.9c.1.3.1.4.1.5z",
                },
              }),
              _c("path", {
                staticClass: "st4",
                attrs: {
                  d: "M1094.1 166.1c-3.3 21.4-.5 30.9-.7 51-.1 5.9 1.1 22.3 1.5 22.9.6.8 8.7 1.5 9.7 1.5 6 .3 5.2-.9 11.1-1.6 3.3-13.8 2.9-16.2 6.2-30 3-12.9 4.7-27.3 3.7-40.4-1.2-18.1-28.3-24.1-31.5-3.4z",
                },
              }),
              _c(
                "g",
                [
                  _c(
                    "linearGradient",
                    {
                      attrs: {
                        id: "SVGID_56_",
                        gradientUnits: "userSpaceOnUse",
                        x1: "-1858.133",
                        y1: "1079.822",
                        x2: "-1596.482",
                        y2: "1034.923",
                        gradientTransform:
                          "matrix(-.1022 0 0 -.1021 935.398 304.332)",
                      },
                    },
                    [
                      _c("stop", {
                        staticStyle: { "stop-color": "#a1e7fc" },
                        attrs: { offset: "0" },
                      }),
                      _c("stop", {
                        staticStyle: { "stop-color": "#a1e7fc" },
                        attrs: { offset: "1" },
                      }),
                    ],
                    1
                  ),
                  _c("path", {
                    staticStyle: { fill: "url(#SVGID_56_)" },
                    attrs: {
                      d: "M1096.9 209.3c0-3-.4-6-.7-9-.4-3.5-.8-7.1-.6-10.6.1-4.5 1.1-9 2-13.4 1.4-6.6 2.8-13.5 1.5-20.2.7-.6 1.5-1.2 2.4-1.6 1.6 7.4.2 15.1-1.1 22.6-1 5.6-2.1 11.5-1.9 17.2.1 1.9.3 3.8.5 5.6.2 2.1.5 4.2.5 6.3.1 3.9-.5 7.8-1.1 11.7-1 6.7-2 13.7.5 20.1l1 2.5-1-4.8c-1.5-5.7-.6-11.8.3-17.7.6-3.9 1.2-7.9 1.1-11.8 0-2.1-.3-4.3-.5-6.4-.2-1.8-.4-3.7-.5-5.6-.2-5.7.9-11.5 1.9-17.1 1.4-7.6 2.8-15.4 1.1-23 1.9-.9 3.9-1.3 6-1.3 1.6 2.2 1.8 5.2.5 7.5-.2.4-.5.8-.8 1.2-.7 1-1.5 2.1-1.4 3.4 0 1.1.6 2 1.2 3 .5.9 1.1 1.7 1.1 2.6.1 1.3-.8 2.4-1.7 3.5-.9 1.2-1.9 2.4-1.8 3.9 0 1.2.8 2.3 1.5 3.3s1.4 1.9 1.4 3c0 1.2-.8 2.3-1.6 3.4s-1.7 2.3-1.7 3.7c0 1.2.7 2.2 1.3 3.2.7 1.1 1.3 2.1 1.2 3.2-.2 1.1-1 1.9-1.9 2.7-.9.8-1.8 1.6-2.1 2.8-.4 1.5.4 3 1.3 4.3.8 1.4 1.6 2.7 1.2 4-.3.8-1 1.5-1.7 2.2-.9.9-1.8 1.8-1.8 3 0 1 .6 1.8 1.2 2.7.5.8 1.1 1.5 1.1 2.3 0 .9-.6 1.7-1.3 2.5-.2.3-.4.5-.6.8-1.3 1.8-1.6 4.2-.9 6.3.1.3.4.5.8.5h.1c.4-.1-.1-.6-.1-.6-.1 0-.1 0-.2-.1-.7-2-.4-4.2.8-5.9.2-.3.4-.5.6-.8.7-.9 1.4-1.8 1.4-2.9 0-1-.6-1.8-1.2-2.6-.5-.8-1.1-1.5-1.1-2.3 0-1 .8-1.8 1.7-2.6.7-.7 1.5-1.5 1.8-2.5.5-1.5-.4-3-1.2-4.4-.8-1.3-1.5-2.6-1.2-3.9.3-1 1.1-1.7 1.9-2.5.9-.9 1.9-1.8 2.1-3 .2-1.3-.5-2.5-1.2-3.6-.6-1-1.2-1.9-1.2-2.9 0-1.2.8-2.2 1.6-3.3.9-1.1 1.7-2.3 1.7-3.7 0-1.2-.8-2.3-1.5-3.3s-1.3-1.9-1.4-3c0-1.3.8-2.4 1.7-3.5.9-1.2 1.9-2.4 1.8-3.9 0-1.1-.6-2-1.2-2.9-.6-.9-1.1-1.7-1.1-2.7 0-1.1.6-2.1 1.3-3.1.3-.4.6-.8.8-1.2 1.4-2.4 1.2-5.4-.3-7.7 2.2.1 4.4.7 6.4 1.6.9 8 .3 16.1-1.6 24-.1.6-.3 1.2-.5 1.8-.6 2.2-1.1 4.5-1.3 6.7-.2 2.5.1 5 .4 7.5.3 2.8.7 5.8.3 8.6-.4 2.4-1.3 4.8-2.2 7.1-.6 1.6-1.3 3.3-1.8 5-1.2 4.5-1.1 9.3-1 13.9.1 4.1.2 8.3-.6 12.3h-2.3c-.9 0-6.9-.5-9-1.2-1.3-6.1-.5-12.5.3-18.7.2-3.9.7-8.1.6-12.2z",
                    },
                  }),
                  _c(
                    "linearGradient",
                    {
                      attrs: {
                        id: "SVGID_57_",
                        gradientUnits: "userSpaceOnUse",
                        x1: "-1867.553",
                        y1: "1063.077",
                        x2: "-1605.648",
                        y2: "1018.136",
                        gradientTransform:
                          "matrix(-.1022 0 0 -.1021 935.398 304.332)",
                      },
                    },
                    [
                      _c("stop", {
                        staticStyle: { "stop-color": "#a1e7fc" },
                        attrs: { offset: "0" },
                      }),
                      _c("stop", {
                        staticStyle: { "stop-color": "#a1e7fc" },
                        attrs: { offset: "1" },
                      }),
                    ],
                    1
                  ),
                  _c("path", {
                    staticStyle: { fill: "url(#SVGID_57_)" },
                    attrs: {
                      d: "M1108.3 229.2c-.1-4.6-.2-9.3 1-13.7.5-1.7 1.1-3.3 1.7-4.9.9-2.3 1.9-4.7 2.2-7.2.4-2.9.1-5.9-.3-8.8-.3-2.4-.6-4.9-.4-7.4.2-2.2.7-4.5 1.3-6.6.2-.6.3-1.2.5-1.8 1.9-7.8 2.5-15.8 1.7-23.7 2.7 1.4 5.1 3.5 6.9 6.1.2 1.5-.1 2.9-.9 4.2-.2.4-.6.8-.8 1.2-.8 1-1.6 2.1-1.6 3.4 0 1.1.6 2.1 1.2 3 .6.9 1.1 1.7 1.1 2.6 0 1.3-.9 2.4-1.8 3.5-1 1.2-2 2.4-2 3.8 0 1.2.8 2.3 1.5 3.3s1.4 1.9 1.4 3c0 1.2-.8 2.2-1.7 3.3-.9 1.1-1.9 2.3-1.9 3.7 0 1.2.7 2.2 1.3 3.2.7 1.1 1.4 2.1 1.2 3.2-.2 1.1-1.1 1.8-2.1 2.7-1 .8-1.9 1.6-2.3 2.8-.4 1.5.4 3 1.2 4.4.8 1.4 1.6 2.7 1.2 4-.3.8-1.1 1.5-1.8 2.2-1 .9-2 1.7-2 3 0 1 .6 1.9 1.2 2.7.6.8 1.1 1.5 1.1 2.3 0 .9-.7 1.7-1.4 2.5-.2.3-.5.5-.7.8-2 2.5-1.9 6.1.1 8.5l.6.8-.8-2.1c-1.2-2.2-1-4.9.5-6.9.2-.3.4-.5.7-.8.8-.9 1.5-1.7 1.6-2.8 0-1-.6-1.8-1.2-2.6s-1.1-1.5-1.1-2.3c0-1 .9-1.8 1.8-2.6.8-.7 1.6-1.5 2-2.4.5-1.5-.3-3-1.2-4.4-.8-1.4-1.6-2.6-1.2-3.9.3-1 1.2-1.7 2.1-2.5 1-.9 2.1-1.7 2.3-3 .2-1.3-.5-2.5-1.2-3.6-.6-1-1.2-1.9-1.2-2.9 0-1.2.8-2.2 1.7-3.3.9-1.1 1.9-2.3 1.9-3.7 0-1.2-.8-2.3-1.5-3.3s-1.4-1.9-1.4-3c0-1.3.9-2.3 1.9-3.5 1-1.2 2-2.4 2-3.9 0-1.1-.6-2-1.2-2.9-.6-.9-1.1-1.8-1.1-2.7 0-1.1.7-2 1.5-3l.9-1.2c.6-1 1-2.2 1.1-3.4 1.2 2.1 1.9 4.5 2.1 7.2.9 13.1-.7 27.6-3.7 40.4-3.3 13.8-2.9 16.2-6.2 30-4.7.5-5.2 1.4-8.2 1.6.6-4.3.5-8.5.4-12.6z",
                    },
                  }),
                  _c(
                    "linearGradient",
                    {
                      attrs: {
                        id: "SVGID_58_",
                        gradientUnits: "userSpaceOnUse",
                        x1: "-1837.875",
                        y1: "1106.506",
                        x2: "-1586.519",
                        y2: "1063.373",
                        gradientTransform:
                          "matrix(-.1022 0 0 -.1021 935.398 304.332)",
                      },
                    },
                    [
                      _c("stop", {
                        staticStyle: { "stop-color": "#a1e7fc" },
                        attrs: { offset: "0" },
                      }),
                      _c("stop", {
                        staticStyle: { "stop-color": "#a1e7fc" },
                        attrs: { offset: "1" },
                      }),
                    ],
                    1
                  ),
                  _c("path", {
                    staticStyle: { fill: "url(#SVGID_58_)" },
                    attrs: {
                      d: "M1094.1 166.1c.6-4.2 2.3-7.3 4.4-9.4 1.2 6.4-.2 13.1-1.6 19.5-.9 4.4-1.9 9-2 13.5-.1 3.6.3 7.2.6 10.7.3 2.9.6 6 .7 8.9 0 4-.5 8.2-1 12.2-.6 4.5-1.1 9.2-.9 13.7-.5-5.4-1-14.2-1-18.1.4-20.2-2.5-29.6.8-51z",
                    },
                  }),
                ],
                1
              ),
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_59_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "-1807.414",
                    y1: "554.376",
                    x2: "-1448.752",
                    y2: "554.376",
                    gradientTransform:
                      "matrix(-.1022 0 0 -.1021 935.398 304.332)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#eee" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#d6d7d8" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_59_)" },
                attrs: { d: "M1083.5 229.5h36.7V266h-36.7z" },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c("g", [
        _c("g", [
          _c("defs", [
            _c("path", {
              attrs: { id: "SVGID_60_", d: "M1146 53h125v214h-125z" },
            }),
          ]),
          _c("clipPath", { attrs: { id: "SVGID_61_" } }, [
            _c("use", {
              staticStyle: { overflow: "visible" },
              attrs: { "xlink:href": "#SVGID_60_" },
            }),
          ]),
          _c(
            "g",
            { staticStyle: { "clip-path": "url(#SVGID_61_)" } },
            [
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_62_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "1894.302",
                    y1: "-474.475",
                    x2: "2588.667",
                    y2: "-474.475",
                    gradientTransform:
                      "matrix(.08768 0 0 -.08792 979.903 118.618)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#a1e7fc" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#a1e7fc" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_62_)" },
                attrs: {
                  d: "M1206.3 89.4c.2-.2.3-.4.5-.5h-.3c1.5-6-1.4-12.3-5.4-16.9-1.8-2.1-3.9-4-6.5-4.8-2.7-.9-5.6-.4-8.4.3-8 2-15.4 6.4-21.1 12.5-1.8 2-3.6 4.5-3.1 7.1.6 3 3.9 5.7 2.5 8.3-1.4 2.8-6.2 1.8-7.9 4.4-2.6 4 5.6 8.8 3.4 13.1-1.1 2.2-4.1 2.4-6.3 3.4-4.3 1.9-6 8-3.3 11.9 2.4 3.4 7.7 5.9 6.7 9.9-.4 1.4-1.5 2.5-2.5 3.6-3.4 3.4-6.3 7.4-7.8 12-1.4 4.6-1.2 9.9 1.4 14 1.3 2.1 3.2 3.8 5.1 5.3 9.5 7.8 13.2 16 20.8 25.6 4.8 6 15.4 44.7 18 55.5 2-15.8 6.5-62.9 8.4-65.5 1.9-2.6 2.9-6.3 1.3-9.1-1.2-2-3.4-3.1-5.3-4.5s-3.7-3.5-3.3-5.8c.2-1.1.9-2 1.6-2.8 2.2-2.7 4.7-5.1 6.3-8.2 1.6-3.1 2-7.1 0-9.9-1.9-2.6-5.6-3.8-8.4-5.4 2.4-1.9 6-3.2 8.1-5.6 1.5-1.9 2.1-4.5 1.5-6.8-.7-2.5-2.5-4.4-4-6.4.3-1.2.2-2.4-.5-3.5-.4-.6-.9-1-1.5-1.4-.1-1.2.2-2.4 1-3.4 1.2-1.4 3.3-1.8 4.7-3.1 2.2-2.1 1.4-6.3-1.3-7.5-1.6-.7-3.9-.9-4.2-2.6v-.6c4-3.9 8.3-7.4 9.8-12.6z",
                },
              }),
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_63_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "2335.863",
                    y1: "-628.798",
                    x2: "2877.975",
                    y2: "-628.798",
                    gradientTransform:
                      "matrix(.08768 0 0 -.08792 979.903 118.618)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#deeafe" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#e9f1fe" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_63_)" },
                attrs: {
                  d: "M1227.5 180c-1.1-2.8-3.7-5-4.3-8-.8-4.4 3.1-8 5.5-11.6 3.7-5.5 4.6-12.9 2.2-19.1-2.3-6.2-7.8-11.2-14.2-12.9-4.1-1.1-8.6-1-12.2-3.1-4.9-3-8.9-10.1-14.3-8.1-3.8 1.3-4.7 6.5-3.4 10.4 1.3 3.8 3.9 7.1 5.1 11 2.2 7.4-1.4 15.1-4.2 22.3-2.9 7.2-4.8 16-.1 22.1 2.3 3 6.1 4.9 7.4 8.4 1.8 4.8-1.5 9.8-3.2 14.6-3.1 9 .4 19.9 8.2 25.4.3-11.5 5.6-22.7 14.3-30.2 3.4-2.9 7.2-5.2 10.1-8.6 2.9-3.7 4.7-8.5 3.1-12.6z",
                },
              }),
              _c("path", {
                staticClass: "st13",
                attrs: {
                  d: "M1187.8 248.6s-.1 0 0 0c-.4 0-.6-.3-.5-.6 2.5-17.6 6.2-34.2 11.1-49.1.1-.3.4-.4.7-.3.3.1.4.4.3.7-4.8 14.9-8.6 31.4-11 49-.1.1-.4.3-.6.3z",
                },
              }),
              _c("path", {
                staticClass: "st18",
                attrs: {
                  d: "M1192.7 191.8c1.5-2.2 5.6-2 9.1.4s5.2 6.1 3.7 8.3-5.6 2-9.1-.4-5.1-6.1-3.7-8.3z",
                },
              }),
              _c("path", {
                staticClass: "st13",
                attrs: {
                  d: "M1199.9 196.2h-.2c-.3-.1-.4-.4-.3-.7 2.5-7.3 5.3-14.5 8.4-21.2.1-.3.4-.4.7-.3.3.1.4.4.3.7-3.1 6.7-5.9 13.8-8.4 21.1-.1.2-.3.4-.5.4z",
                },
              }),
              _c("path", {
                staticClass: "st18",
                attrs: {
                  d: "M1200 165.2c1.5-2.2 7-1 12.3 2.6 5.3 3.6 8.4 8.4 6.9 10.6-1.5 2.2-7 1-12.3-2.6-5.3-3.6-8.4-8.4-6.9-10.6z",
                },
              }),
              _c("path", {
                staticClass: "st13",
                attrs: {
                  d: "M1209.4 172.7c-.1 0-.2 0-.2-.1-.3-.1-.4-.4-.2-.7.9-2 1.9-3.9 2.9-5.8 2.7-5.2 5.7-10.4 8.8-15.2.2-.2.5-.3.7-.2.2.2.3.5.2.7-3.1 4.8-6.1 9.9-8.8 15.2-1 1.9-2 3.8-2.9 5.8-.1.2-.3.3-.5.3z",
                },
              }),
              _c("path", {
                staticClass: "st18",
                attrs: {
                  d: "M1212.3 139.5c1.8-1.8 7.3 1 12.4 6.1 5.1 5.2 7.8 10.8 6.1 12.5-1.8 1.8-7.3-1-12.4-6.1s-7.8-10.7-6.1-12.5z",
                },
              }),
              _c("path", {
                staticClass: "st13",
                attrs: {
                  d: "M1222.7 149.2c-.1 0-.2 0-.3-.1-.2-.2-.3-.5-.1-.7 4.2-6.3 8.8-12.3 13.6-17.8.2-.2.5-.2.7 0 .2.2.2.5 0 .7-4.8 5.5-9.4 11.4-13.5 17.7 0 .1-.2.2-.4.2z",
                },
              }),
              _c("path", {
                staticClass: "st18",
                attrs: {
                  d: "M1231.3 112.7c3.1-1.4 8.8 4.9 12.8 14 3.9 9.1 4.6 17.6 1.5 18.9-3.1 1.4-8.8-4.9-12.8-14-3.9-9-4.6-17.5-1.5-18.9z",
                },
              }),
              _c("path", {
                staticClass: "st13",
                attrs: {
                  d: "M1238.9 128.6c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7 5-5.4 10.3-10.4 15.8-14.9.2-.2.5-.1.7.1.2.2.1.6-.1.7-5.5 4.5-10.7 9.4-15.7 14.8 0 .1-.2.1-.3.1z",
                },
              }),
              _c("path", {
                staticClass: "st18",
                attrs: {
                  d: "M1243.7 95c2.6-2.2 10.7 3.3 18 12.2 7.3 8.9 11.1 17.9 8.5 20-2.6 2.2-10.7-3.3-18-12.2-7.3-8.8-11.1-17.8-8.5-20z",
                },
              }),
              _c("path", {
                staticClass: "st13",
                attrs: {
                  d: "M1257.3 111.6c-.2 0-.3-.1-.4-.2-.2-.2-.1-.6.1-.7 3.6-2.8 7.4-5.5 11.2-7.8.2-.2.6-.1.7.2.2.2.1.6-.2.7-3.8 2.4-7.5 5-11.1 7.8h-.3z",
                },
              }),
              _c("path", {
                staticClass: "st9",
                attrs: {
                  d: "m1197 258.5-1.9-5.7c-.1-.3.1-.6.3-.7h.2c-1.2-27.7-1.9-60.2 1.8-93.3.2-1.6.4-3.2.6-4.7 0-.3.3-.5.6-.5s.5.3.5.6c-.2 1.5-.4 3.1-.6 4.7-3.8 34-3 67.5-1.6 95.7l.1 3.9z",
                },
              }),
              _c("path", {
                staticClass: "st13",
                attrs: {
                  d: "M1191.6 154.4c-.4-1.4 2.4-3.4 6.1-4.5 3.8-1 7.1-.7 7.5.7s-2.4 3.4-6.1 4.5c-3.8 1-7.1.7-7.5-.7z",
                },
              }),
              _c("path", {
                staticClass: "st9",
                attrs: {
                  d: "M1198.8 152.5s-.1 0 0 0c-.4 0-.6-.3-.5-.6 1.3-9.7 2.9-19.1 4.9-28.1.1-.3.3-.5.6-.4.3.1.5.3.4.6-2 9-3.6 18.4-4.8 28.1-.1.2-.4.4-.6.4z",
                },
              }),
              _c("path", {
                staticClass: "st13",
                attrs: {
                  d: "M1194.7 124.7c-.4-1.4 3.2-3.6 7.9-5s8.9-1.2 9.3.2-3.2 3.6-7.9 5c-4.8 1.3-8.9 1.2-9.3-.2z",
                },
              }),
              _c("path", {
                staticClass: "st9",
                attrs: {
                  d: "M1204.1 122.1h-.1c-.3-.1-.5-.3-.4-.6 1.8-8.2 4-16.2 6.5-23.9.1-.3.4-.4.7-.3.3.1.4.4.3.7-2.4 7.6-4.6 15.6-6.4 23.8-.1.2-.3.3-.6.3z",
                },
              }),
              _c("ellipse", {
                staticClass: "st13",
                attrs: {
                  transform: "rotate(-85.049 1210.44 95.776) scale(1.00003)",
                  cx: "1210.4",
                  cy: "95.8",
                  rx: "4.2",
                  ry: "11.3",
                },
              }),
              _c("path", {
                staticClass: "st9",
                attrs: {
                  d: "M1211.5 95.4h-.2c-.3-.1-.4-.4-.3-.7 1.8-5.4 3.8-10.8 5.9-16 .1-.3.4-.4.7-.3.3.1.4.4.3.7-2.1 5.1-4.1 10.5-5.9 15.9 0 .2-.2.4-.5.4z",
                },
              }),
              _c("path", {
                staticClass: "st13",
                attrs: {
                  d: "M1206.3 74.7c.3-2.1 5.8-3 12.2-2 6.4 1 11.4 3.6 11 5.7-.3 2.1-5.8 3-12.2 2-6.4-1-11.3-3.6-11-5.7z",
                },
              }),
              _c("path", {
                staticClass: "st9",
                attrs: {
                  d: "M1218.5 76.9h-.2c-.3-.1-.4-.4-.3-.7 1.4-3.2 2.8-6.5 4.3-9.6.5-.9.9-1.9 1.4-2.8.1-.3.4-.4.7-.2.3.1.4.4.2.7-.5.9-.9 1.9-1.4 2.8-1.5 3.1-2.9 6.3-4.3 9.6 0 .1-.2.2-.4.2z",
                },
              }),
              _c("path", {
                staticClass: "st13",
                attrs: {
                  d: "M1211.1 59.5c.4-2.6 6.7-3.7 14-2.5 7.3 1.2 12.9 4.2 12.5 6.7-.4 2.6-6.7 3.7-14 2.5s-12.9-4.2-12.5-6.7z",
                },
              }),
              _c("path", {
                staticClass: "st9",
                attrs: {
                  d: "M1226 60.9c-.1 0-.2 0-.2-.1-.3-.1-.4-.4-.2-.7 1.2-2.4 2.5-4.7 3.8-6.9.1-.2.5-.3.7-.2.2.1.3.5.2.7-1.3 2.2-2.5 4.5-3.8 6.9-.1.2-.3.3-.5.3z",
                },
              }),
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_64_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "2203.527",
                    y1: "-1394.347",
                    x2: "2667.206",
                    y2: "-1394.347",
                    gradientTransform:
                      "matrix(.08768 0 0 -.08792 979.903 118.618)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#eee" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#d6d7d8" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_64_)" },
                attrs: { d: "M1173.1 215.4h40.7V267h-40.7z" },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }